export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Long: { input: number; output: number; }
};

export type AccountStatusResult = {
  __typename?: 'AccountStatusResult';
  circuitBreak: Scalars['Boolean']['output'];
  holder?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type AddCartPayloadResponse = {
  __typename?: 'AddCartPayloadResponse';
  edge: CartEdge;
  type: CartBehavior;
};

export type AgreeToOriginInputResponsibilityInput = {
  agreedAt: Scalars['DateTime']['input'];
  baId: Scalars['ID']['input'];
};

export type AgreeToOriginInputResponsibilityResult = {
  __typename?: 'AgreeToOriginInputResponsibilityResult';
  businessAccount?: Maybe<BusinessAccount>;
  error?: Maybe<ErrorAgreeToOriginInputResponsibility>;
};

/** 스토어프로필 상품판매 이용약관 동의 입력 */
export type AgreeToStoreProductSaleInput = {
  agreedAt: Scalars['DateTime']['input'];
  storeId: Scalars['ID']['input'];
};

export type AgreeToStoreProfileProductSaleError = InvalidStore | StoreNotFound | UnauthorizedStoreAccess;

/** 스토어프로필 상품판매 이용약관 동의 결과 */
export type AgreeToStoreProfileProductSaleResult = {
  __typename?: 'AgreeToStoreProfileProductSaleResult';
  error?: Maybe<AgreeToStoreProfileProductSaleError>;
  store?: Maybe<Store>;
};

/** 답변 상태 */
export enum AnswerStatus {
  /** 전체 */
  All = 'ALL',
  /** 답변됨 */
  Answered = 'ANSWERED',
  /** 미답변 */
  Unanswered = 'UNANSWERED'
}

export type ApprovePaymentError = PaymentPassThroughError;

export type ApprovePaymentInput = {
  checkoutId: Scalars['ID']['input'];
  payId: Scalars['ID']['input'];
};

/** 결제 승인 결과 */
export type ApprovePaymentResponse = {
  __typename?: 'ApprovePaymentResponse';
  error?: Maybe<ApprovePaymentError>;
  orderSheet?: Maybe<OrderSheet>;
};

export type AskAiDataInput = {
  /** destination 별 입력 페이로드. */
  args?: InputMaybe<Scalars['JSON']['input']>;
  /** 요청을 라우팅할 AI 백엔드. */
  destination: AskAiDestination;
  /** destination 측 프로젝트 식별자. */
  projectId: Scalars['String']['input'];
  /** destination 이 PROMPT_STUDIO 인 경우의 옵션. */
  promptStudioOptions?: InputMaybe<PromptStudioOptions>;
};

export enum AskAiDestination {
  PromptStudio = 'PROMPT_STUDIO'
}

export type AskAiResult = {
  __typename?: 'AskAIResult';
  /** 응답을 제공할 수 없는 경우의 사유. 정상 응답이면 null. */
  notAvailable?: Maybe<Scalars['String']['output']>;
  /** destination 별 응답 페이로드. */
  result: Scalars['JSON']['output'];
};

/**  key 랑 value 정리해야함 */
export type Attribute = {
  __typename?: 'Attribute';
  attributeValue: Scalars['String']['output'];
  dataKey: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  originalValue: Scalars['String']['output'];
  value: AttributeValue;
};

export type AttributeValue = ListStringAttributeValue | StringAttributeValue;

/** 결제 시 사용 가능한 쿠폰 */
export type AvailableCoupon = {
  __typename?: 'AvailableCoupon';
  /** 적용 가능한 쿠폰 금액 */
  applicableCouponAmount?: Maybe<Money>;
  /** 쿠폰 ID */
  couponId: Scalars['ID']['output'];
  /** 쿠폰 설명 */
  description: Scalars['String']['output'];
  /** 유의 사항 */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** 매칭된 결제 항목 목록 */
  matchedPayItems: Array<MatchedPayItem>;
  /** 최대 할인 금액 */
  maximumDiscountAmount?: Maybe<Money>;
  /** 최소 주문 금액 */
  minimumOrderAmount?: Maybe<Money>;
  /** 쿠폰 이름 */
  name: Scalars['String']['output'];
  /** 템플릿 ID */
  templateId: Scalars['ID']['output'];
};

/** 사용 가능 쿠폰 Connection */
export type AvailableCouponConnection = {
  __typename?: 'AvailableCouponConnection';
  edges: Array<AvailableCouponEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** 사용 가능 쿠폰 Edge */
export type AvailableCouponEdge = {
  __typename?: 'AvailableCouponEdge';
  cursor: Scalars['ID']['output'];
  node: AvailableCoupon;
};

/** 사용 가능한 쿠폰 조회 필터 */
export type AvailableCouponsFilter = {
  /** 쿠폰 적용 대상 카테고리 (예: promotion_spring2026) */
  category?: InputMaybe<Scalars['String']['input']>;
};

export type BankCodeName = {
  __typename?: 'BankCodeName';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Banner = {
  __typename?: 'Banner';
  image: Image;
  targetUri: Scalars['String']['output'];
};

export type BulkDeliveryStartRequest = Node & {
  __typename?: 'BulkDeliveryStartRequest';
  failResultExcelScheme?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rowCountBy: Scalars['Int']['output'];
  rowTotalCount: Scalars['Int']['output'];
  status: BulkDeliveryStartRequestStatus;
};


export type BulkDeliveryStartRequestRowCountByArgs = {
  status?: InputMaybe<BulkDeliveryStartRequestRowStatus>;
};

/**  엑셀의 로우 처리 상태 */
export enum BulkDeliveryStartRequestRowStatus {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export enum BulkDeliveryStartRequestStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type BusinessAccount = Node & {
  __typename?: 'BusinessAccount';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  adminUserBanner?: Maybe<BusinessAccountUserAdminBanner>;
  /** 이용약관 동의 정보 */
  agreement?: Maybe<BusinessAccountAgreement>;
  /** 사업자 속성 정보 (통신판매신고번호 등) */
  businessAttribute?: Maybe<BusinessAccountAttribute>;
  businessRegistration?: Maybe<BusinessRegistration>;
  category?: Maybe<BusinessAccountCategory>;
  /** 채팅 직거래 정보 */
  chatDirectTradeMonitoring?: Maybe<ChatDirectTradeMonitoring>;
  chatRoomScheme?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enableNotifyFeature?: Maybe<Scalars['Boolean']['output']>;
  features: Array<BusinessAccountFeature>;
  followersCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  images: Array<Image>;
  /** 채팅 주문의 타겟 여부 */
  isChatOrderTarget: Scalars['Boolean']['output'];
  isFollowing?: Maybe<Scalars['Boolean']['output']>;
  jibunAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  /** 로컬 프로필 ID */
  lpId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationLevel?: Maybe<NotificationLevel>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Image>;
  region?: Maybe<Region>;
  reviewsCount: Scalars['Int']['output'];
  roadAddress?: Maybe<Scalars['String']['output']>;
  /**  해당 필드의 경우, 조회에 외부 호출이 필요해, 성능에 영향을 줄 수 있음(https://www.notion.so/daangn/a09a70e8921a4c72a482110a01b30edb) */
  safeNumber?: Maybe<Scalars['String']['output']>;
  /** 판매 방식 설정 */
  saleMethodSetting?: Maybe<SaleMethodSetting>;
  settlement?: Maybe<BusinessAccountSettlement>;
  status: BusinessAccountStatus;
  /**
   *  입점신청
   * @deprecated No longer supported
   */
  storeRequest?: Maybe<StoreRequest>;
  /**  입점신청 가능 여부 */
  storeRequestAbility?: Maybe<StoreRequestAbility>;
  type: BusinessAccountType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** 비즈프로필 이용약관 동의 정보 */
export type BusinessAccountAgreement = {
  __typename?: 'BusinessAccountAgreement';
  /** 원산지 입력 책임 동의 시각 (null = 동의 안함) */
  agreeToOriginInputResponsibilityAt?: Maybe<Scalars['DateTime']['output']>;
  /** 채팅주문 이용약관 동의 시각 (null = 동의 안함) */
  agreedToChatOrderTermsOfServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /** 상품판매 이용약관 동의 시각 (null = 동의 안함) */
  agreedToTermsOfServiceAt?: Maybe<Scalars['DateTime']['output']>;
};

/** 사업자 속성 정보 (BusinessVerificationService에서 조회) */
export type BusinessAccountAttribute = {
  __typename?: 'BusinessAccountAttribute';
  /** 사업장 주소 (지번 주소 우선, 없으면 도로명 주소) */
  address: Scalars['String']['output'];
  /** 업종 */
  businessItem?: Maybe<Scalars['String']['output']>;
  /** 상호명 */
  businessName: Scalars['String']['output'];
  /** 사업자등록번호 */
  businessNumber: Scalars['String']['output'];
  /** 사업자등록증 이미지 URL 목록 */
  businessRegistrationImageUrls: Array<Scalars['String']['output']>;
  /** 업태 */
  businessType?: Maybe<Scalars['String']['output']>;
  /** 연락처 */
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']['output']>;
  /** 지번 주소 */
  jibunAddress?: Maybe<Scalars['String']['output']>;
  /** 통신판매신고번호 */
  onlineSaleNumber?: Maybe<Scalars['String']['output']>;
  /** 대표자명 */
  ownerName: Scalars['String']['output'];
  /** 도로명 주소 */
  roadAddress?: Maybe<Scalars['String']['output']>;
};

export type BusinessAccountCategory = {
  __typename?: 'BusinessAccountCategory';
  id: Scalars['ID']['output'];
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
};

export enum BusinessAccountComponentBadge {
  Delivery = 'DELIVERY',
  /**  배송 */
  FreeDelivery = 'FREE_DELIVERY',
  /**  당일배송 */
  RepurchaseALot = 'REPURCHASE_A_LOT',
  /**  무료배송 */
  SameDayDelivery = 'SAME_DAY_DELIVERY'
}

export type BusinessAccountCurationComponent = CurationComponent & Node & {
  __typename?: 'BusinessAccountCurationComponent';
  badge?: Maybe<BusinessAccountComponentBadge>;
  businessAccount: BusinessAccount;
  description: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
};

export type BusinessAccountEdge = {
  __typename?: 'BusinessAccountEdge';
  cursor: Scalars['ID']['output'];
  node: BusinessAccount;
};

export type BusinessAccountFeature = {
  __typename?: 'BusinessAccountFeature';
  enabled: Scalars['String']['output'];
  featureName: Scalars['String']['output'];
};

export enum BusinessAccountInspectionStatus {
  Approved = 'APPROVED',
  Initial = 'INITIAL',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** 비즈니스 계정을 찾을 수 없음 */
export type BusinessAccountNotFound = {
  __typename?: 'BusinessAccountNotFound';
  message: Scalars['String']['output'];
};

export type BusinessAccountSettlement = {
  __typename?: 'BusinessAccountSettlement';
  /**  계좌번호 */
  accountNumber: Scalars['String']['output'];
  /**  통장 사본 */
  accountPhotoId: Scalars['String']['output'];
  /**  은행명 */
  bankName: Scalars['String']['output'];
  /**  연락처 */
  contact: Scalars['String']['output'];
  /**  이메일 주소 */
  email: Scalars['String']['output'];
  /**  예금주명 */
  name: Scalars['String']['output'];
};

export enum BusinessAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum BusinessAccountType {
  Brand = 'BRAND',
  Default = 'DEFAULT',
  Individual = 'INDIVIDUAL',
  Mandatory = 'MANDATORY',
  Official = 'OFFICIAL',
  Public = 'PUBLIC',
  Widget = 'WIDGET'
}

export enum BusinessAccountUserAdminBanner {
  Inactive = 'INACTIVE',
  InspectionPending = 'INSPECTION_PENDING',
  InspectionRejected = 'INSPECTION_REJECTED',
  InspectionRequired = 'INSPECTION_REQUIRED',
  /**  정산 중지 */
  KycImminent = 'KYC_IMMINENT',
  /**  유예기간 / 만료예정 */
  KycPending = 'KYC_PENDING',
  /**  인증 진행중 */
  KycRejected = 'KYC_REJECTED',
  KycRequired = 'KYC_REQUIRED',
  MetaDataRequired = 'META_DATA_REQUIRED'
}

export type BusinessRegistration = {
  __typename?: 'BusinessRegistration';
  inspectionStatus: BusinessAccountInspectionStatus;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessStatusResult = {
  __typename?: 'BusinessStatusResult';
  circuitBreak: Scalars['Boolean']['output'];
  isAlreadyRegistered?: Maybe<Scalars['Boolean']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type Buyer = {
  __typename?: 'Buyer';
  chatRoomScheme?: Maybe<Scalars['String']['output']>;
  chatRoomWebUrl?: Maybe<Scalars['String']['output']>;
  /**  default type is PER_PRODUCT */
  purchaseCount: Scalars['Int']['output'];
  user?: Maybe<HoianUser>;
};


export type BuyerPurchaseCountArgs = {
  type?: InputMaybe<PurchaseCountType>;
};

/** 구매자용 전용 필터 */
export type BuyerStoreOrderFilter = {
  /** DEFAULT - 상품판매&스토어프로필, CHAT - 채팅주문 */
  channels?: InputMaybe<Array<OrderChannelType>>;
};

/** 캠페인 */
export type Campaign = Node & {
  __typename?: 'Campaign';
  /** 캠페인 로컬 ID */
  _id: Scalars['ID']['output'];
  /** 연관 쿠폰 목록 */
  couponTemplates: Array<CampaignCoupon>;
  /** 캠페인 설명 */
  description?: Maybe<Scalars['String']['output']>;
  /** 캠페인 종료일시 */
  endedAt: Scalars['DateTime']['output'];
  /** Relay Global ID */
  id: Scalars['ID']['output'];
  /** 알림 정보 */
  notification?: Maybe<CampaignNotification>;
  /** 연관 상품 목록 */
  products: Array<Product>;
  /** 캠페인 시작일시 */
  startedAt: Scalars['DateTime']['output'];
  /** 캠페인 상태 */
  status: CampaignStatus;
  /** 캠페인 제목 */
  title: Scalars['String']['output'];
  /** 캠페인 유형 */
  type: CampaignType;
};

/** 캠페인 쿠폰 */
export type CampaignCoupon = {
  __typename?: 'CampaignCoupon';
  /** 쿠폰 템플릿 ID */
  couponTemplateId: Scalars['ID']['output'];
  /** 결제 유형 */
  paymentType: PaymentType;
  /** 남은 발급 가능 수량 */
  remainingQuantity?: Maybe<Scalars['Int']['output']>;
  /** 총 발급 가능 수량 */
  totalQuantity?: Maybe<Scalars['Int']['output']>;
};

/** 캠페인에서 쿠폰 발급이 불가능 */
export type CampaignCouponNotAvailable = {
  __typename?: 'CampaignCouponNotAvailable';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 캠페인 그룹 */
export type CampaignGroup = Node & {
  __typename?: 'CampaignGroup';
  /** 그룹 키 */
  _id: Scalars['ID']['output'];
  /** 캠페인 내용 */
  campaigns: Array<Campaign>;
  /** Relay Global ID */
  id: Scalars['ID']['output'];
};

/** 캠페인을 찾을 수 없음 */
export type CampaignNotFound = {
  __typename?: 'CampaignNotFound';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 캠페인 알림 정보 */
export type CampaignNotification = {
  __typename?: 'CampaignNotification';
  /** 현재 사용자의 알림 구독 여부 (비로그인 시 null) */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** 현재 사용자의 마케팅 수신 동의 정보 (비로그인 시 null) */
  marketingConsent?: Maybe<MarketingConsent>;
};

/** 캠페인이 알림을 지원하지 않음 */
export type CampaignNotificationNotSupported = {
  __typename?: 'CampaignNotificationNotSupported';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 캠페인 상태 */
export enum CampaignStatus {
  /** 진행 중 */
  Active = 'ACTIVE',
  /** 종료 */
  Ended = 'ENDED',
  /** 예정 */
  Scheduled = 'SCHEDULED'
}

/** 캠페인 유형 */
export enum CampaignType {
  /** 선착순 쿠폰 */
  FirstComeCoupon = 'FIRST_COME_COUPON',
  /** 프로모션 페이지 제어 */
  Page = 'PAGE'
}

export type CancelInfo = {
  __typename?: 'CancelInfo';
  canceledAt: Scalars['DateTime']['output'];
  canceledBy: OrderCanceledBy;
  payment: CanceledPayment;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CancelOrderInput = {
  cancelReason: Scalars['String']['input'];
  storeOrderId: Scalars['ID']['input'];
};

export type CancelOrderResponse = CancelOrderSuccess | ExceedBuyerCancelTimeLimitError;

export type CancelOrderSuccess = Node & {
  __typename?: 'CancelOrderSuccess';
  id: Scalars['ID']['output'];
  orderSheet: OrderSheet;
};

/** 리액션 취소. */
export type CancelStoreProfileReviewReactionInput = {
  reactionType?: StoreProfileReviewReactionType;
  reviewId: Scalars['ID']['input'];
};

export type CancelStoreProfileReviewReactionResult = {
  __typename?: 'CancelStoreProfileReviewReactionResult';
  error?: Maybe<ErrorCancelStoreProfileReviewReaction>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

export type CanceledPayment = Payment & {
  __typename?: 'CanceledPayment';
  /**  취소 일시 */
  canceledAt: Scalars['DateTime']['output'];
  /**  쿠폰 할인 */
  couponDiscountAmount?: Maybe<Money>;
  /**  배송비 */
  deliveryFee: Money;
  /**  할인 총합 */
  discountAmount: Money;
  /**  환불 수단 */
  method: PaymentMethod;
  /**  주문금액 */
  orderAmount: Money;
  /**  총 환불금액 */
  paymentAmount: Money;
  /**  상품 할인 */
  productDiscountAmount?: Maybe<Money>;
};

export type Cart = Node & {
  __typename?: 'Cart';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  payload: Array<CartPayload>;
  productType: Type;
  receiveMethod?: Maybe<ReceiveMethod>;
  store: Store;
  totalQuantity: Scalars['Int']['output'];
};

/**  cart가 update 되었는지 혹은 cart가 새로 생성되었는지 여부 */
export enum CartBehavior {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type CartConnection = {
  __typename?: 'CartConnection';
  edges: Array<CartEdge>;
  pageInfo: PageInfo;
};

export type CartEdge = {
  __typename?: 'CartEdge';
  cursor: Scalars['ID']['output'];
  node: Cart;
};

export type CartPayload = {
  __typename?: 'CartPayload';
  product: Product;
  selectedOptions: Array<CartSelectedOption>;
};

export type CartPayloadInput = {
  productId: Scalars['ID']['input'];
  receiveMethod?: InputMaybe<ReceiveMethod>;
  selectedOptions: Array<CartSelectedOptionInput>;
};

export type CartSelectedOption = {
  __typename?: 'CartSelectedOption';
  name?: Maybe<Scalars['String']['output']>;
  option?: Maybe<ProductOptionSet>;
  quantity: Scalars['Int']['output'];
};

export type CartSelectedOptionInput = {
  optionId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** 직거래 판매자 차단 이력 */
export type ChatDirectTradeBlockHistory = {
  __typename?: 'ChatDirectTradeBlockHistory';
  baId: Scalars['ID']['output'];
  /** 제재 유형 (가입 전/후) */
  blockType: ChatDirectTradeBlockType;
  /** 차단 일시 */
  blockedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 신고 ID */
  reportId?: Maybe<Scalars['String']['output']>;
  /** 신고 항목 ID */
  reportItemId?: Maybe<Scalars['Int']['output']>;
};

/** 직거래 제재 유형 */
export enum ChatDirectTradeBlockType {
  /** 채팅주문 가입 후 제재 */
  AfterChatOrderJoin = 'AFTER_CHAT_ORDER_JOIN',
  /** 채팅주문 가입 전 제재 */
  BeforeChatOrderJoin = 'BEFORE_CHAT_ORDER_JOIN'
}

/** 직거래 판매자 정보 */
export type ChatDirectTradeMonitoring = {
  __typename?: 'ChatDirectTradeMonitoring';
  baId: Scalars['ID']['output'];
  /** 최초 감지일 */
  firstDetectedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 마지막 감지일 */
  lastDetectedAt: Scalars['DateTime']['output'];
  /** 최근 제재 이력 (제재된 경우에만 존재) */
  latestBlockHistory?: Maybe<ChatDirectTradeBlockHistory>;
  /** 누적 경고 횟수 */
  warningCount: Scalars['Int']['output'];
};

export type ChatMetadataInput = {
  channelId: Scalars['String']['input'];
};

/** 채팅주문 배송비 옵션 */
export type ChatOrderDeliveryFeeOption = {
  __typename?: 'ChatOrderDeliveryFeeOption';
  /** 배송비 금액 */
  fee: Money;
  /** 배송비 옵션명 (예: '기본', '제주&도서산간') */
  name: Scalars['String']['output'];
};

/** 잘못된 주문 */
export type ChatOrderInvalidOrder = {
  __typename?: 'ChatOrderInvalidOrder';
  message: Scalars['String']['output'];
};

/** 채팅 주문 정책 */
export type ChatOrderPolicy = {
  __typename?: 'ChatOrderPolicy';
  /** 정책시행일 (경고/차단 적용 시작) */
  enforcementStartAt: Scalars['DateTime']['output'];
  /** 계도기간 시작일 */
  guidanceStartAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 채팅주문 가입 전 제재 신고 항목 ID */
  reportItemId: Scalars['Int']['output'];
  /** 채팅주문 가입 후 제재 신고 항목 ID */
  reportItemIdJoined: Scalars['Int']['output'];
  /** 경고 횟수 임계값 (초과 시 차단) */
  warningCountThreshold: Scalars['Int']['output'];
};

/** 채팅주문 상품 후보 (최신 소식 기준) */
export type ChatOrderPost = {
  __typename?: 'ChatOrderPost';
  /** 소식 ID */
  businessPostId: Scalars['ID']['output'];
  /** 해당 소식의 상품 후보 목록 */
  products: Array<ChatOrderProduct>;
  /** 소식 제목 */
  title: Scalars['String']['output'];
};

/** 채팅주문 상품 후보 */
export type ChatOrderProduct = {
  __typename?: 'ChatOrderProduct';
  _id: Scalars['ID']['output'];
  /** 배송비 옵션 목록 */
  deliveryFeeOptions: Array<ChatOrderDeliveryFeeOption>;
  /** 상품명 */
  name: Scalars['String']['output'];
  /** 옵션 목록 */
  options: Array<ChatOrderProductOption>;
  /** 상품 가격 (옵션 없는 단일 상품의 경우) */
  price?: Maybe<Money>;
  /** 상품 후보 썸네일 */
  thumbnail?: Maybe<Image>;
};

/** 채팅주문 상품 옵션 */
export type ChatOrderProductOption = {
  __typename?: 'ChatOrderProductOption';
  _id: Scalars['ID']['output'];
  /** 옵션명 (예: '2kg', '1개') */
  name: Scalars['String']['output'];
  /** 옵션 가격 */
  price?: Maybe<Money>;
};

/** 스토어를 찾을 수 없음 */
export type ChatOrderStoreNotFound = {
  __typename?: 'ChatOrderStoreNotFound';
  message: Scalars['String']['output'];
};

/** 스토어 소유권 없음 */
export type ChatOrderStoreNotOwned = {
  __typename?: 'ChatOrderStoreNotOwned';
  message: Scalars['String']['output'];
};

export type ChatStoreOrder = {
  __typename?: 'ChatStoreOrder';
  storeOrder: StoreOrder;
};

export type ChatStoreOrderProductOptionInput = {
  name: Scalars['String']['input'];
  price: MoneyInput;
  quantity: Scalars['Int']['input'];
};

export type ChatStoreProductInput = {
  /** 상품별 배송비 (다상품 결제 시 모든 상품의 배송비 합이 1회 묶음 배송비로 적용됩니다) */
  deliveryFee?: InputMaybe<MoneyInput>;
  /** 상품 옵션 목록 (지정 시 옵션의 price/quantity 가 0순위로 사용되며, 상위 price/quantity 는 무시됩니다) */
  options?: InputMaybe<Array<ChatStoreOrderProductOptionInput>>;
  /** 상품 대표 이미지 ID (소식 기반 채팅주문 시 사용) */
  pictureId?: InputMaybe<Scalars['ID']['input']>;
  price: MoneyInput;
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CheckInRegion = {
  __typename?: 'CheckInRegion';
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lastActiveAt: Scalars['DateTime']['output'];
  region: Region;
};

export type Checkout = Node & {
  __typename?: 'Checkout';
  _id: Scalars['ID']['output'];
  body: StoreOrder;
  defaultDeliveryAddress?: Maybe<DeliveryAddress>;
  deliveryRequirementMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recentCustomerInfo?: Maybe<CustomerInfo>;
};

/**  UI 상단에 노출될 상품 그룹핑 칩 */
export type Chip = {
  __typename?: 'Chip';
  /**  local id */
  _id?: Maybe<Scalars['String']['output']>;
  /**  global id */
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ClearAllCartsResponse = {
  __typename?: 'ClearAllCartsResponse';
  cartIds: Array<Scalars['ID']['output']>;
};

export type Collection = {
  __typename?: 'Collection';
  products: ProductConnection;
};


export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type CompletePayment = Payment & {
  __typename?: 'CompletePayment';
  /**  쿠폰 할인 */
  couponDiscountAmount?: Maybe<Money>;
  /**  결제 일시 */
  createdAt: Scalars['DateTime']['output'];
  /**  배송비 */
  deliveryFee?: Maybe<Money>;
  /**  할인 총합 */
  discountAmount: Money;
  /**  결제 수단 */
  method: PaymentMethod;
  /**  주문금액 */
  orderAmount: Money;
  /**  총 결제금액 */
  paymentAmount: Money;
  /**  상품 할인 */
  productDiscountAmount?: Maybe<Money>;
};

/**  조건부 무료 배송 */
export type ConditionalFreeDelivery = Delivery & Node & {
  __typename?: 'ConditionalFreeDelivery';
  _id: Scalars['ID']['output'];
  /**  배송비 */
  fee: Money;
  /**  배송비 무료 조건 금액 */
  freeConditionPrice: Money;
  id: Scalars['ID']['output'];
};

export type ConfirmPurchaseInput = {
  storeOrderId: Scalars['ID']['input'];
};

export type Content = PostWrapperForProduceHomeFeed | PostWrapperForSearch | ProductWrapperForSearch;

/** 이미 발급된 쿠폰 */
export type CouponAlreadyIssued = {
  __typename?: 'CouponAlreadyIssued';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 쿠폰 상세 */
export type CouponDetail = Node & {
  __typename?: 'CouponDetail';
  /** 쿠폰 로컬 ID */
  _id: Scalars['ID']['output'];
  /** 쿠폰 사용 상태 */
  couponStatus: IssuedCouponStatus;
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 쿠폰 설명 */
  description: Scalars['String']['output'];
  /** 유의 사항 */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** 할인 정책 */
  discountPolicy: CouponDiscountPolicy;
  /** 만료일자 */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Relay Global ID */
  id: Scalars['ID']['output'];
  /** 최소 결제 금액 */
  minimumPaymentAmount?: Maybe<Money>;
  /** 쿠폰 이름 */
  name: Scalars['String']['output'];
  /** 템플릿 ID */
  templateId: Scalars['ID']['output'];
  /** 사용 가능 대상 목록 */
  usableTargets: Array<UsableTarget>;
};

/** 쿠폰 상세 Connection */
export type CouponDetailConnection = {
  __typename?: 'CouponDetailConnection';
  edges: Array<CouponDetailEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** 쿠폰 상세 Edge */
export type CouponDetailEdge = {
  __typename?: 'CouponDetailEdge';
  cursor: Scalars['ID']['output'];
  node: CouponDetail;
};

/** 쿠폰 할인 정책 */
export type CouponDiscountPolicy = {
  __typename?: 'CouponDiscountPolicy';
  /** 할인 금액 (정액 할인 시) */
  amount?: Maybe<Money>;
  /** 할인 비율 (정률 할인 시) */
  discountRatio?: Maybe<Scalars['Float']['output']>;
  /** 최대 할인 금액 (정률 할인 시) */
  maxDiscountAmount?: Maybe<Money>;
  /** 할인 유형 */
  type: CouponDiscountType;
};

/** 쿠폰 할인 유형 */
export enum CouponDiscountType {
  /** 정액 할인 */
  FixedAmount = 'FIXED_AMOUNT',
  /** 정률 할인 */
  Percentage = 'PERCENTAGE'
}

/** 쿠폰 만료 정책 */
export type CouponExpirationPolicy = {
  __typename?: 'CouponExpirationPolicy';
  /** 발급일 기준 유효 일수 (발급일 기준 시) */
  daysFromStart?: Maybe<Scalars['Long']['output']>;
  /** 만료일자 */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** 만료 유형 */
  type: CouponExpirationType;
};

/** 쿠폰 만료 유형 */
export enum CouponExpirationType {
  /** 발급일 기준 N일 */
  DaysFromStart = 'DAYS_FROM_START',
  /** 고정 기간 */
  FixedPeriod = 'FIXED_PERIOD',
  /** 발급일 기준 N일 23:59:59 */
  RelativePeriod = 'RELATIVE_PERIOD'
}

/** 쿠폰이 모두 소진됨 */
export type CouponStockExhausted = {
  __typename?: 'CouponStockExhausted';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 발급 가능한 쿠폰 템플릿 */
export type CouponTemplate = Node & {
  __typename?: 'CouponTemplate';
  /** 템플릿 로컬 ID */
  _id: Scalars['ID']['output'];
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 쿠폰 설명 */
  description: Scalars['String']['output'];
  /** 유의 사항 */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** 할인 정책 */
  discountPolicy: CouponDiscountPolicy;
  /** 만료 정책 */
  expirationPolicy: CouponExpirationPolicy;
  /** Relay Global ID */
  id: Scalars['ID']['output'];
  /** 남은 발급 가능 수량 (무제한일 경우 null) */
  issuableRemainCount?: Maybe<Scalars['Long']['output']>;
  /** 매칭된 발급 대상 정보 */
  matchedIssuanceTarget?: Maybe<IssuanceTargetInfo>;
  /** 최소 결제 금액 */
  minimumPaymentAmount?: Maybe<Money>;
  /** 쿠폰 이름 */
  name: Scalars['String']['output'];
};

/** 쿠폰 템플릿 Connection */
export type CouponTemplateConnection = {
  __typename?: 'CouponTemplateConnection';
  edges: Array<CouponTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** 쿠폰 템플릿 Edge */
export type CouponTemplateEdge = {
  __typename?: 'CouponTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: CouponTemplate;
};

/** 쿠폰 템플릿을 찾을 수 없음 */
export type CouponTemplateNotFound = {
  __typename?: 'CouponTemplateNotFound';
  /** 에러 메시지 */
  message: Scalars['String']['output'];
};

/** 쿠폰 템플릿 조회 필터 */
export type CouponTemplatesFilter = {
  /** 발급 대상 정보 목록 */
  issuanceTargetInfos?: InputMaybe<Array<IssuanceTargetInfoInput>>;
  /** 결제 유형 */
  paymentType: PaymentType;
};

export type CreateBookmarkInput = {
  productId: Scalars['ID']['input'];
};

export type CreateChatStoreOrderError = ChatOrderInvalidOrder | ChatOrderStoreNotFound | ChatOrderStoreNotOwned;

/**  ========== 채팅 주문 생성 ========== */
export type CreateChatStoreOrderInput = {
  buyerAccountId: Scalars['String']['input'];
  entry?: InputMaybe<Scalars['String']['input']>;
  /** 주문 메타데이터 */
  metadata?: InputMaybe<StoreOrderMetadataInput>;
  products: Array<ChatStoreProductInput>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['ID']['input'];
};

export type CreateChatStoreOrderResult = {
  __typename?: 'CreateChatStoreOrderResult';
  chatStoreOrder?: Maybe<ChatStoreOrder>;
  error?: Maybe<CreateChatStoreOrderError>;
};

export type CreateDeliveryAddressInput = {
  detBdNm?: InputMaybe<Scalars['String']['input']>;
  detailAddress: Scalars['String']['input'];
  frontEntrancePassword?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  jusoApiResultAsJsonStr?: InputMaybe<Scalars['String']['input']>;
  recipientContact: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
  roadNameAddress: Scalars['String']['input'];
  townNumberAddress: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateDeliveryAddressResponse = {
  __typename?: 'CreateDeliveryAddressResponse';
  edge: DeliveryAddressEdge;
};

export type CreateGoodsProductInput = {
  productDeliverySetting?: InputMaybe<ProductDeliverySettingInput>;
  receiveMethods: Array<ReceiveMethod>;
};

export type CreateInquiryAnswerResult = {
  __typename?: 'CreateInquiryAnswerResult';
  error?: Maybe<ErrorCreateInquiryAnswer>;
  productInquiry?: Maybe<ProductInquiry>;
};

/**  Response Types */
export type CreateInquiryResult = {
  __typename?: 'CreateInquiryResult';
  error?: Maybe<ErrorCreateInquiry>;
  productInquiry?: Maybe<ProductInquiry>;
};

export type CreateOrderPayloadInput = {
  saleId: Scalars['ID']['input'];
  selectedOptionSets: Array<SelectedOptionSetInput>;
};

export type CreateProductInput = {
  attributes?: InputMaybe<Array<ProductAttributeInput>>;
  categoryId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  discountExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  goodsInput?: InputMaybe<CreateGoodsProductInput>;
  name: Scalars['String']['input'];
  price: MoneyInput;
  /**  to be not null */
  productType: Type;
  salePrice?: InputMaybe<MoneyInput>;
  serviceInput?: InputMaybe<CreateServiceProductInput>;
  simpleOptions: Array<SimpleOptionsInput>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  taxType?: InputMaybe<TaxType>;
  templates?: InputMaybe<Array<TemplateItemInput>>;
  thumbnailIds: Array<Scalars['ID']['input']>;
};

export type CreateProductInquiryAnswerInput = {
  /** 내용 */
  content: Scalars['String']['input'];
  /** 답변이 필요한 문의하기 ID */
  parentInquiryId: Scalars['ID']['input'];
  /** 상품 ID */
  productId: Scalars['ID']['input'];
};

export type CreateProductInquiryInput = {
  /** 내용 */
  content: Scalars['String']['input'];
  /** 숨김처리 여부 */
  isSecret: Scalars['Boolean']['input'];
  /** 상품 ID */
  productId: Scalars['ID']['input'];
};

export type CreateReportInput = {
  detail?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reporterType: ReporterType;
  targetId: Scalars['ID']['input'];
  targetType: ReportTargetType;
};

export type CreateReviewCommentInput = {
  content: Scalars['String']['input'];
  reviewId: Scalars['ID']['input'];
};

export type CreateReviewInput = {
  content: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  pictureIds: Array<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  tagIds: Array<Scalars['Int']['input']>;
};

export type CreateReviewResponse = {
  __typename?: 'CreateReviewResponse';
  reviewEdge: ReviewEdge;
};

export type CreateServiceProductInput = {
  benefit?: InputMaybe<Scalars['String']['input']>;
  validDays: Scalars['Int']['input'];
};

export type CreateStoreAndAgreementError = BusinessAccountNotFound | InvalidSaleMethodSetting | TermsNotAgreed;

/** 스토어 생성 및 이용약관 동의 입력 */
export type CreateStoreAndAgreementRequestInput = {
  /** 채팅주문 이용약관 동의 시각 */
  agreedToChatOrderTermsOfServiceAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** 상품판매 이용약관 동의 시각 */
  agreedToTermsOfServiceAt?: InputMaybe<Scalars['DateTime']['input']>;
  baId: Scalars['ID']['input'];
};

export type CreateStoreAndAgreementResult = {
  __typename?: 'CreateStoreAndAgreementResult';
  error?: Maybe<CreateStoreAndAgreementError>;
  /** 스토어가 신규 생성되었는지 여부 */
  isNewStore?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<Store>;
};

export type CreateStoreOrderInput = {
  entry?: InputMaybe<Scalars['String']['input']>;
  payloads: Array<CreateOrderPayloadInput>;
  receiveMethod?: InputMaybe<ReceiveMethod>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['ID']['input'];
  totalPrice: MoneyInput;
};

/** 사장님 답글 작성. 한 후기당 1건. */
export type CreateStoreProfileReviewCommentInput = {
  content: Scalars['String']['input'];
  reviewId: Scalars['ID']['input'];
};

/** 사장님 답글 mutation 의 성공 응답은 답글이 반영된 부모 후기(StoreProfileReview). */
export type CreateStoreProfileReviewCommentResult = {
  __typename?: 'CreateStoreProfileReviewCommentResult';
  error?: Maybe<ErrorCreateStoreProfileReviewComment>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

/** 후기 작성 요청. */
export type CreateStoreProfileReviewInput = {
  /** 후기 본문. 공백만 있는 값은 거부. */
  content: Scalars['String']['input'];
  /** 첨부 미디어 (최대 10개). */
  mediaObjects?: Array<StoreProfileReviewMediaInput>;
  /** 작성 대상 주문. */
  orderId: Scalars['ID']['input'];
  /** 별점 (1 ~ 5). */
  rating: Scalars['Int']['input'];
  /** 선택한 큐레이션 태그의 ReviewTagCategory.id 목록. */
  tagIds?: Array<Scalars['ID']['input']>;
};

/**
 *  ============================================================
 *  Result types
 *    성공 시 storeProfileReview, 실패 시 mutation 별 error union 으로 분기.
 *    UnexpectedError 는 inquiry.graphqls 에 정의된 공용 catch-all error 타입.
 *  ============================================================
 */
export type CreateStoreProfileReviewResult = {
  __typename?: 'CreateStoreProfileReviewResult';
  error?: Maybe<ErrorCreateStoreProfileReview>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

export type CreateStoreRequestV2Input = {
  /** 채팅주문 이용약관 동의 시각 (chatOrderEnabled=true 시 필수) */
  agreedToChatOrderTermsOfServiceAt?: InputMaybe<Scalars['DateTime']['input']>;
  agreedToTermsOfServiceAt: Scalars['DateTime']['input'];
  baId: Scalars['ID']['input'];
  /** 채팅주문 활성화 여부 (기본값: false) */
  chatOrderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 상품 판매 활성화 여부 (기본값: true) */
  productSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 스토어 타입 (기본값: LOCAL_PROFILE) */
  storeType?: InputMaybe<StoreType>;
};

export type Curation = Node & {
  __typename?: 'Curation';
  _id: Scalars['String']['output'];
  components?: Maybe<CurationComponentConnection>;
  displayCart?: Maybe<Scalars['Boolean']['output']>;
  floatingButton?: Maybe<CurationFloatingButton>;
  id: Scalars['ID']['output'];
  shareScheme?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type CurationComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CurationAlarmReceiver = Node & {
  __typename?: 'CurationAlarmReceiver';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: CurationAlarmReceiverStatus;
  userId: Scalars['String']['output'];
};

export enum CurationAlarmReceiverStatus {
  Canceled = 'CANCELED',
  Requested = 'REQUESTED'
}

export type CurationComponent = {
  id: Scalars['ID']['output'];
};

export type CurationComponentConnection = {
  __typename?: 'CurationComponentConnection';
  edges: Array<CurationComponentEdge>;
  pageInfo: PageInfo;
};

export type CurationComponentEdge = {
  __typename?: 'CurationComponentEdge';
  cursor: Scalars['String']['output'];
  node: CurationComponent;
};

export type CurationComponentMoreButton = {
  __typename?: 'CurationComponentMoreButton';
  minimumItmeCountLimit?: Maybe<Scalars['Int']['output']>;
  targetUri: Scalars['String']['output'];
};

export type CurationFloatingButton = {
  __typename?: 'CurationFloatingButton';
  targetUri: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CustomCurationComponent = CurationComponent & Node & {
  __typename?: 'CustomCurationComponent';
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export type CustomProductSource = {
  __typename?: 'CustomProductSource';
  name: Scalars['String']['output'];
  originalProductId: Scalars['ID']['output'];
  price: Money;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  contact: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requirements?: Maybe<Scalars['String']['output']>;
};

export type CustomerInfoInput = {
  contact: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirements?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAllSearchKeywordResponse = {
  __typename?: 'DeleteAllSearchKeywordResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBookmarkInput = {
  productId: Scalars['ID']['input'];
};

export type DeleteDeliveryAddressResponse = {
  __typename?: 'DeleteDeliveryAddressResponse';
  defaultAddressEdge?: Maybe<DeliveryAddressEdge>;
  deletedAddress: DeliveryAddress;
};

export type DeleteInquiryResult = {
  __typename?: 'DeleteInquiryResult';
  deletedInquiry?: Maybe<ProductInquiry>;
  error?: Maybe<ErrorDeleteInquiry>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLatestSearchKeywordInput = {
  historyId: Scalars['String']['input'];
};

export type DeleteLatestSearchKeywordResponse = {
  __typename?: 'DeleteLatestSearchKeywordResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductInquiryInput = {
  /** 문의하기 ID */
  inquiryId: Scalars['ID']['input'];
};

export type DeleteReviewCommentInput = {
  reviewCommentId: Scalars['ID']['input'];
  reviewId: Scalars['ID']['input'];
};

export type DeleteReviewInput = {
  reviewId: Scalars['ID']['input'];
};

/** 사장님 답글 삭제. 본인 BA 답글만. */
export type DeleteStoreProfileReviewCommentInput = {
  commentId: Scalars['ID']['input'];
};

export type DeleteStoreProfileReviewCommentResult = {
  __typename?: 'DeleteStoreProfileReviewCommentResult';
  error?: Maybe<ErrorDeleteStoreProfileReviewComment>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

/** 후기 soft-delete 요청. 작성자 본인만. */
export type DeleteStoreProfileReviewInput = {
  reviewId: Scalars['ID']['input'];
};

export type DeleteStoreProfileReviewResult = {
  __typename?: 'DeleteStoreProfileReviewResult';
  error?: Maybe<ErrorDeleteStoreProfileReview>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

export enum DeliverableRegionType {
  /**  일부 지역 배송 */
  Partial = 'PARTIAL',
  /**  전체 지역 배송 */
  Whole = 'WHOLE'
}

export type Delivery = {
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type DeliveryAddress = Node & {
  __typename?: 'DeliveryAddress';
  _id: Scalars['ID']['output'];
  deliveryRequirementMessage?: Maybe<Scalars['String']['output']>;
  detailAddress: Scalars['String']['output'];
  detailBuildingName?: Maybe<Scalars['String']['output']>;
  frontEntrancePassword?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  recipientContact: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  roadNameAddress: Scalars['String']['output'];
  townNumberAddress: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type DeliveryAddressConnection = {
  __typename?: 'DeliveryAddressConnection';
  edges: Array<DeliveryAddressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeliveryAddressEdge = {
  __typename?: 'DeliveryAddressEdge';
  cursor: Scalars['ID']['output'];
  node: DeliveryAddress;
};

export enum DeliveryCompany {
  /**  CJ대한통운 */
  Cj = 'CJ',
  /**  대신 */
  Daeshin = 'DAESHIN',
  /**  건영 */
  Geonyoung = 'GEONYOUNG',
  /**  경동 */
  Gyeongdong = 'GYEONGDONG',
  /**  한진 */
  Hanjin = 'HANJIN',
  /**  일양로지스 */
  Ilyang = 'ILYANG',
  /**  롯데 */
  Logen = 'LOGEN',
  /**  롯데택배 */
  Lotte = 'LOTTE',
  /**  농협 */
  Nonghyup = 'NONGHYUP',
  /**  우체국택배 */
  PostOffice = 'POST_OFFICE',
  /**  SLX */
  Slx = 'SLX',
  /**  용마로지스 */
  Yongma = 'YONGMA'
}

export type DeliveryInfo = {
  __typename?: 'DeliveryInfo';
  status: DeliveryStatus;
};

export type DeliveryPolicy = {
  __typename?: 'DeliveryPolicy';
  /**  delivery fee, free delivery if null */
  deliveryFee?: Maybe<Money>;
  /**  delivery free or not */
  deliveryFree: Scalars['Boolean']['output'];
  /**  minimum price for free delivery fee, free delivery if null */
  deliveryFreeConditionPrice?: Maybe<Money>;
};

export type DeliveryProductAdditionalFields = {
  __typename?: 'DeliveryProductAdditionalFields';
  deliverySetting?: Maybe<StoreDeliverySetting>;
  name: Scalars['String']['output'];
};

export type DeliveryRequirementInput = {
  isReuseChecked: Scalars['Boolean']['input'];
  requirements?: InputMaybe<Scalars['String']['input']>;
};

export enum DeliverySettingFeeType {
  ConditionalFree = 'CONDITIONAL_FREE',
  Fixed = 'FIXED',
  Free = 'FREE'
}

export enum DeliverySettingType {
  /**  일반 배송 */
  Normal = 'NORMAL',
  /**  당일 배송 */
  SameDay = 'SAME_DAY'
}

export enum DeliveryStatus {
  BeforeDelivery = 'BEFORE_DELIVERY',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryPrepare = 'DELIVERY_PREPARE',
  DeliveryStarted = 'DELIVERY_STARTED'
}

export enum DeliveryType {
  ConditionalFree = 'CONDITIONAL_FREE',
  Fixed = 'FIXED',
  Free = 'FREE'
}

export type DepositAndConfirmInfo = {
  __typename?: 'DepositAndConfirmInfo';
  accountNumber: Scalars['String']['output'];
  accountOwner: Scalars['String']['output'];
  baId: Scalars['String']['output'];
  bank: Scalars['String']['output'];
  confirmApproveAggregation: SettlementAggregateData;
  confirmEndDate: Scalars['Date']['output'];
  confirmRefundAggregation: SettlementAggregateData;
  confirmStartDate: Scalars['Date']['output'];
  debtAmount: Scalars['Int']['output'];
  depositAmount: Scalars['Int']['output'];
  depositDueDate: Scalars['Date']['output'];
  depositStatus: DepositStatus;
  id: Scalars['ID']['output'];
  totalConfirmAmount: Scalars['Int']['output'];
  totalServiceFeeAmount: Scalars['Int']['output'];
  totalSupportCouponAmount: Scalars['Int']['output'];
};

export type DepositAndConfirmInfoConnection = {
  __typename?: 'DepositAndConfirmInfoConnection';
  edges: Array<DepositAndConfirmInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DepositAndConfirmInfoEdge = {
  __typename?: 'DepositAndConfirmInfoEdge';
  cursor: Scalars['ID']['output'];
  node: DepositAndConfirmInfo;
};

export enum DepositStatus {
  Adjustment = 'ADJUSTMENT',
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Ready = 'READY'
}

/**  Daily Settlement Query Data */
export type DepositSummary = {
  __typename?: 'DepositSummary';
  baId: Scalars['String']['output'];
  inProgressAggregate: SettlementAggregateData;
  totalDepositAmount: Scalars['Int']['output'];
};

/** 할인 정보 */
export type DiscountInput = {
  discountType: DiscountType;
  productId?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['ID']['input'];
};

/** 할인 타입 */
export enum DiscountType {
  Coupon = 'COUPON'
}

/** 이미 답글이 달려있을 때 (create comment 에서만 — 후기당 1건 제약). */
export type DuplicatedStoreProfileReviewCommentError = {
  __typename?: 'DuplicatedStoreProfileReviewCommentError';
  message: Scalars['String']['output'];
};

/** 같은 주문에 이미 활성 후기가 있을 때 (1 주문 1 후기 정책). create 에서만 발생. */
export type DuplicatedStoreProfileReviewError = {
  __typename?: 'DuplicatedStoreProfileReviewError';
  message: Scalars['String']['output'];
};

/** 같은 (review, user, reactionType) 조합에 이미 리액션이 있을 때. react 에서만 발생. */
export type DuplicatedStoreProfileReviewReactionError = {
  __typename?: 'DuplicatedStoreProfileReviewReactionError';
  message: Scalars['String']['output'];
};

export type ErrorAgreeToOriginInputResponsibility = BusinessAccountNotFound | UnauthorizedBusinessAccountAccess | UnexpectedError;

export type ErrorCancelStoreProfileReviewReaction = NotFoundStoreProfileReviewError | NotFoundStoreProfileReviewReactionError | UnexpectedError;

export type ErrorCreateInquiry = InvalidProductInquiry | NotFoundProduct | UnexpectedError;

export type ErrorCreateInquiryAnswer = InquiryAlreadyAnswered | InvalidProductInquiry | ParentInquiryNotFound | UnexpectedError;

export type ErrorCreateStoreProfileReview = DuplicatedStoreProfileReviewError | InvalidStoreProfileReviewError | RestrictedStoreProfileReviewError | UnexpectedError;

export type ErrorCreateStoreProfileReviewComment = DuplicatedStoreProfileReviewCommentError | InvalidStoreProfileReviewError | NotFoundStoreProfileReviewError | UnauthorizedStoreProfileReviewError | UnexpectedError;

export type ErrorDeleteInquiry = InquiryNotFound | UnauthorizedInquiryAccess | UnexpectedError;

export type ErrorDeleteStoreProfileReview = NotFoundStoreProfileReviewError | UnauthorizedStoreProfileReviewError | UnexpectedError;

export type ErrorDeleteStoreProfileReviewComment = NotFoundStoreProfileReviewCommentError | UnauthorizedStoreProfileReviewError | UnexpectedError;

/** 캠페인 쿠폰 발급 에러 */
export type ErrorIssueCampaignCoupon = CampaignCouponNotAvailable | CampaignNotFound | CouponAlreadyIssued | CouponStockExhausted | UnexpectedError;

/** 쿠폰 발급 에러 */
export type ErrorIssueCoupon = CouponAlreadyIssued | CouponTemplateNotFound | UnexpectedError;

export type ErrorReactToStoreProfileReview = DuplicatedStoreProfileReviewReactionError | NotFoundStoreProfileReviewError | UnexpectedError;

/** 캠페인 구독 에러 */
export type ErrorSubscribeCampaign = CampaignNotFound | CampaignNotificationNotSupported | UnexpectedError;

/** 캠페인 구독 해제 에러 */
export type ErrorUnsubscribeCampaign = CampaignNotFound | CampaignNotificationNotSupported | UnexpectedError;

export type ErrorUpdateInquiry = InquiryNotFound | InvalidProductInquiry | UnauthorizedInquiryAccess | UnexpectedError;

export type ErrorUpdateStoreProfileReview = InvalidStoreProfileReviewError | NotFoundStoreProfileReviewError | UnauthorizedStoreProfileReviewError | UnexpectedError;

export type ErrorUpdateStoreProfileReviewComment = InvalidStoreProfileReviewError | NotFoundStoreProfileReviewCommentError | UnauthorizedStoreProfileReviewError | UnexpectedError;

/**  Buyer가 주문 취소 가능한 시간이 존재합니다. 해당 시간을 넘기면 발생하는 에러 응답 */
export type ExceedBuyerCancelTimeLimitError = Node & {
  __typename?: 'ExceedBuyerCancelTimeLimitError';
  id: Scalars['ID']['output'];
  orderSheet: OrderSheet;
};

export type Experiment = Node & {
  __typename?: 'Experiment';
  _id: Scalars['ID']['output'];
  flag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export type ExperimentV2 = {
  __typename?: 'ExperimentV2';
  group: Scalars['String']['output'];
  key: Scalars['String']['output'];
  variables: Array<ExperimentVariable>;
};

export type ExperimentVariable = {
  __typename?: 'ExperimentVariable';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variableType?: Maybe<ExperimentVariableType>;
};

export enum ExperimentVariableType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING',
  Unknown = 'UNKNOWN'
}

export type FailureInfo = {
  __typename?: 'FailureInfo';
  code: Scalars['Int']['output'];
  failedAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  reason: FailureReason;
};

export enum FailureReason {
  /**  일반적인 결제 오류 */
  BillKeyError = 'BILL_KEY_ERROR',
  /**
   *  분실 신고 카드
   * @deprecated PASS_THROUGH 분류로 이동.
   */
  CardLossReported = 'CARD_LOSS_REPORTED',
  /**  파이낸스에서 처리 */
  HandleByFinance = 'HANDLE_BY_FINANCE',
  /**
   *  잔액 부족
   * @deprecated PASS_THROUGH 분류로 이동. JPA 영속 호환을 위해 enum 값은 영구 보존.
   */
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  /**
   *  은행 점검
   * @deprecated PASS_THROUGH 분류로 이동.
   */
  InvalidBank = 'INVALID_BANK',
  /**
   *  사용 정지 카드
   * @deprecated PASS_THROUGH 분류로 이동.
   */
  InvalidCard = 'INVALID_CARD',
  /**  쿠폰 상태 이상 */
  InvalidCoupon = 'INVALID_COUPON',
  /**  유효하지 않은 주문 */
  InvalidOrder = 'INVALID_ORDER',
  /**  상품 상태 이상 */
  InvalidProducts = 'INVALID_PRODUCTS',
  /**  스토어 상태 이상 */
  InvalidStore = 'INVALID_STORE',
  /**  재고 부족 */
  OutOfStock = 'OUT_OF_STOCK',
  Unknown = 'UNKNOWN'
}

/**  피처플래그 정보 */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /**  활성화 여부 */
  enabled: Scalars['Boolean']['output'];
  /**  피처플래그 이름 */
  name: FeatureFlagName;
  /**  Variant 정보 (A/B 테스트 등에 사용) */
  variant?: Maybe<FeatureFlagVariant>;
};

/**  피처플래그 정보 (String 기반) */
export type FeatureFlagByName = {
  __typename?: 'FeatureFlagByName';
  /**  활성화 여부 */
  enabled: Scalars['Boolean']['output'];
  /**  피처플래그 이름 */
  name: Scalars['String']['output'];
  /**  Variant 정보 (A/B 테스트 등에 사용) */
  variant?: Maybe<FeatureFlagVariant>;
};

/**  피처플래그 이름 enum */
export enum FeatureFlagName {
  /**  채팅주문 기능 */
  ChatOrder = 'CHAT_ORDER',
  CommerceChatEnforced = 'COMMERCE_CHAT_ENFORCED',
  PostChatOrderProductCandidates = 'POST_CHAT_ORDER_PRODUCT_CANDIDATES',
  /**  스토어 상품 주문 완료 후 추천 상품 제안 */
  PostPurchaseProductRecommendation = 'POST_PURCHASE_PRODUCT_RECOMMENDATION',
  /**  100원딜 프로모션 */
  Promotion_100WonDeal = 'PROMOTION_100WON_DEAL'
}

/**  Variant payload entry (key-value pair) */
export type FeatureFlagPayloadEntry = {
  __typename?: 'FeatureFlagPayloadEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**  피처플래그 Variant 정보 */
export type FeatureFlagVariant = {
  __typename?: 'FeatureFlagVariant';
  /**  Variant 활성화 여부 */
  enabled: Scalars['Boolean']['output'];
  /**  Variant 이름 */
  name: Scalars['String']['output'];
  /**  Variant payload (key-value 형태의 추가 설정) */
  payload: Array<FeatureFlagPayloadEntry>;
};

export type Feedback = {
  __typename?: 'Feedback';
  bookmarked: Scalars['Boolean']['output'];
  bookmarkedCount: Scalars['Int']['output'];
};

/**  배송비 고정 유료 배송 */
export type FixedFeeDelivery = Delivery & Node & {
  __typename?: 'FixedFeeDelivery';
  _id: Scalars['ID']['output'];
  /**  배송비 */
  fee: Money;
  id: Scalars['ID']['output'];
};

/**  무료 배송 */
export type FreeDelivery = Delivery & Node & {
  __typename?: 'FreeDelivery';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type GoodsAdditionalFields = {
  __typename?: 'GoodsAdditionalFields';
  deliverySetting?: Maybe<StoreDeliverySetting>;
  name: Scalars['String']['output'];
  productDeliverySetting?: Maybe<ProductDeliverySetting>;
};

export type HeaderCurationComponent = CurationComponent & Node & {
  __typename?: 'HeaderCurationComponent';
  banner: Banner;
  id: Scalars['ID']['output'];
  subTitle: Array<Maybe<Scalars['String']['output']>>;
  title: Array<Maybe<Scalars['String']['output']>>;
};

export type HoianUser = Node & {
  __typename?: 'HoianUser';
  _id: Scalars['ID']['output'];
  checkInRegion?: Maybe<CheckInRegion>;
  id: Scalars['ID']['output'];
  isFollower: Scalars['Boolean']['output'];
  /** 당근 매너온도 (0.0 ~ 100.0). 외부 user service 에서 hydrate. */
  mannerTemperature: Scalars['Float']['output'];
  nickname: Scalars['String']['output'];
  profile?: Maybe<Image>;
  region?: Maybe<Region>;
};


export type HoianUserIsFollowerArgs = {
  baId: Scalars['ID']['input'];
};

export type Image = Node & {
  __typename?: 'Image';
  _id: Scalars['ID']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  medium: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type InputGroup = {
  __typename?: 'InputGroup';
  nodes: Array<InputGroupNode>;
};

export type InputGroupNode = {
  __typename?: 'InputGroupNode';
  dataKey: Scalars['String']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  initialValue?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  type: InputGroupNodeType;
};

export enum InputGroupNodeType {
  Checkbox = 'CHECKBOX',
  Content = 'CONTENT',
  DateInput = 'DATE_INPUT',
  NumberInput = 'NUMBER_INPUT',
  Textarea = 'TEXTAREA',
  TextInput = 'TEXT_INPUT'
}

/** 이미 답변된 문의 */
export type InquiryAlreadyAnswered = {
  __typename?: 'InquiryAlreadyAnswered';
  message: Scalars['String']['output'];
};

/** 문의를 찾을 수 없음 */
export type InquiryNotFound = {
  __typename?: 'InquiryNotFound';
  message: Scalars['String']['output'];
};

/** 문의하기 작성자 */
export type InquiryWriter = HoianUser | Store;

/** 유효하지 않은 문의하기 */
export type InvalidProductInquiry = {
  __typename?: 'InvalidProductInquiry';
  message: Scalars['String']['output'];
};

/** 유효하지 않은 판매 방식 설정 */
export type InvalidSaleMethodSetting = {
  __typename?: 'InvalidSaleMethodSetting';
  message: Scalars['String']['output'];
};

/** 유효하지 않은 스토어 */
export type InvalidStore = {
  __typename?: 'InvalidStore';
  message: Scalars['String']['output'];
};

/** 입력값이 도메인 불변 조건을 위반했을 때. 예: 별점 범위, 미디어 개수, image/video oneOf 위반. */
export type InvalidStoreProfileReviewError = {
  __typename?: 'InvalidStoreProfileReviewError';
  message: Scalars['String']['output'];
};

/** 발급 대상 정보 */
export type IssuanceTargetInfo = {
  __typename?: 'IssuanceTargetInfo';
  /** 대상 키 */
  targetKey: Scalars['String']['output'];
  /** 대상 값 */
  targetValue: Scalars['String']['output'];
};

/** 발급 대상 정보 입력 */
export type IssuanceTargetInfoInput = {
  /** 대상 키 (예: STORE_ID) */
  targetKey: Scalars['String']['input'];
  /** 대상 값 (예: store-123) */
  targetValue: Scalars['String']['input'];
};

/** 캠페인 쿠폰 발급 입력 */
export type IssueCampaignCouponInput = {
  /** 캠페인 ID */
  campaignId: Scalars['ID']['input'];
  /** 쿠폰 템플릿 ID */
  couponTemplateId: Scalars['ID']['input'];
};

/** 캠페인 쿠폰 발급 결과 */
export type IssueCampaignCouponResult = {
  __typename?: 'IssueCampaignCouponResult';
  /** 에러 */
  error?: Maybe<ErrorIssueCampaignCoupon>;
  /** 발급된 쿠폰 */
  issuedCoupon?: Maybe<IssuedCoupon>;
};

/** 쿠폰 발급 입력 */
export type IssueCouponInput = {
  /** 쿠폰 템플릿 ID */
  couponTemplateId: Scalars['ID']['input'];
  /** 결제 유형 */
  paymentType: PaymentType;
};

/** 쿠폰 발급 결과 */
export type IssueCouponResult = {
  __typename?: 'IssueCouponResult';
  /** 에러 */
  error?: Maybe<ErrorIssueCoupon>;
  /** 발급된 쿠폰 */
  issuedCoupon?: Maybe<IssuedCoupon>;
};

/** 발급된 쿠폰 */
export type IssuedCoupon = Node & {
  __typename?: 'IssuedCoupon';
  /** 쿠폰 로컬 ID */
  _id: Scalars['ID']['output'];
  /** 쿠폰 사용 상태 */
  couponStatus: IssuedCouponStatus;
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 만료일자 */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Relay Global ID */
  id: Scalars['ID']['output'];
  /** 템플릿 ID */
  templateId: Scalars['ID']['output'];
};

/** 발급된 쿠폰 목록 필터 */
export type IssuedCouponFilter = {
  /** 결제 유형 */
  paymentType: PaymentType;
};

/** 쿠폰 사용 상태 */
export enum IssuedCouponStatus {
  /** 만료됨 */
  Expired = 'EXPIRED',
  /** 예약됨 */
  Reserved = 'RESERVED',
  /** 회수됨 */
  Revoked = 'REVOKED',
  /** 사용 가능 */
  Usable = 'USABLE',
  /** 사용 완료 */
  Used = 'USED'
}

/** 지번 주소 */
export type LandAddress = {
  __typename?: 'LandAddress';
  /** 동 */
  dong: Scalars['String']['output'];
  /** 지번 본번 */
  landMainNumber: Scalars['String']['output'];
  /** 시도 */
  sido: Scalars['String']['output'];
  /** 시군구 */
  sigungu: Scalars['String']['output'];
};

export type LatestSearchKeyword = {
  __typename?: 'LatestSearchKeyword';
  createdAt: Scalars['DateTime']['output'];
  historyId: Scalars['String']['output'];
  keyword: Scalars['String']['output'];
};

export type ListStringAttributeValue = {
  __typename?: 'ListStringAttributeValue';
  values: Array<Scalars['String']['output']>;
};

export type Location = {
  type?: Maybe<LocationType>;
};

export enum LocationType {
  Point = 'POINT'
}

/** 마케팅 수신 동의 정보 */
export type MarketingConsent = {
  __typename?: 'MarketingConsent';
  /** 동의 여부 */
  agreed: Scalars['Boolean']['output'];
  /** 동의/변경 일시 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** 매칭된 결제 항목 */
export type MatchedPayItem = {
  __typename?: 'MatchedPayItem';
  /** 결제 항목 금액 */
  amount: Money;
  /** 적용 가능한 쿠폰 금액 */
  applicableCouponAmount: Money;
  /** 카테고리 */
  category?: Maybe<Scalars['String']['output']>;
  /** 참조 ID */
  referenceId: Scalars['ID']['output'];
};

export type Me = {
  __typename?: 'Me';
  experiment?: Maybe<ExperimentV2>;
  /** 내가 작성한 문의 목록 */
  inquiries: ProductInquiryConnection;
  /** 발급된 쿠폰 목록 조회 (쿠폰함) */
  issuedCoupons: CouponDetailConnection;
  recentlyViewedProducts: RecentlyViewedProductConnection;
  /** storeType 인자로 일반 주문만 조회. 채팅 주문은 포함되지 않음, storeType, filter 둘 다 null일 경우 하위호환성 유지를 위해 storeType이 선행 */
  storeOrders: StoreOrderConnection;
  user?: Maybe<HoianUser>;
};


export type MeExperimentArgs = {
  experimentKey: Scalars['ID']['input'];
  trigger?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeInquiriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type MeIssuedCouponsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: IssuedCouponFilter;
};


export type MeRecentlyViewedProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  storeType?: InputMaybe<StoreType>;
};


export type MeStoreOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<BuyerStoreOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  storeType?: InputMaybe<StoreType>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: MoneyCurrency;
};

export enum MoneyCurrency {
  Won = 'WON'
}

export type MoneyInput = {
  amount: Scalars['Long']['input'];
  currency: MoneyCurrency;
};

export type MonthlyOrderSummary = {
  __typename?: 'MonthlyOrderSummary';
  canceledCount: Scalars['Int']['output'];
  confirmedCount: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  month: Scalars['Int']['output'];
  totalAmount: Money;
  year: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  사장님이 주문을 수락함 */
  acceptOrder: OrderSheet;
  /**
   * 별도로 엣지를 한번 감싼 이유는 이래야 스키마에 명시가 가능해요.
   * 명시라 함은 이것을 장바구니 컨넥션에 어펜드를 할거냐 말거냐에요.
   * behavior 가 있는 이유는 그게 동작하지 않을 때를 위한 처리를 하기 위함이에요.
   */
  addCartPayload: AddCartPayloadResponse;
  /** 원산지 입력 책임 동의 */
  agreeToOriginInputResponsibility: AgreeToOriginInputResponsibilityResult;
  /** 스토어프로필 상품판매 이용약관 동의 (스토어프로필 전용, 판매자만 가능) */
  agreeToStoreProductSale: AgreeToStoreProfileProductSaleResult;
  approvePayment: ApprovePaymentResponse;
  cancelCurationAlarm: CurationAlarmReceiver;
  cancelOrder?: Maybe<OrderSheet>;
  cancelOrderV2?: Maybe<CancelOrderResponse>;
  /** 후기 리액션 취소. 등록된 리액션이 있어야 가능. */
  cancelStoreProfileReviewReaction: CancelStoreProfileReviewReactionResult;
  changeOrderInvoice?: Maybe<StartDeliveryResponse>;
  clearAllCarts: ClearAllCartsResponse;
  clickProductInquiry?: Maybe<Scalars['String']['output']>;
  /**  사장님이 직접 배송 완료 처리 */
  completeDelivery: OrderSheet;
  confirmPurchase?: Maybe<OrderSheet>;
  /**  관심 생성 */
  createBookmark?: Maybe<Product>;
  /** 채팅 주문 생성 (단건/다건/옵션 지원) */
  createChatStoreOrder: CreateChatStoreOrderResult;
  createDeliveryAddress: CreateDeliveryAddressResponse;
  /** 문의하기 작성 */
  createInquiry: CreateInquiryResult;
  /** 문의하기 답변 */
  createInquiryAnswer: CreateInquiryAnswerResult;
  createPayAuthCode: PayAuthCode;
  /**  상품 생성 */
  createProduct?: Maybe<Product>;
  /**  최초 상품생성 진입 시 (이탈 시 작성 유도 알림용) */
  createProductDraft?: Maybe<Scalars['Boolean']['output']>;
  createReport?: Maybe<Report>;
  createReviewComment: Review;
  /** 스토어 생성 및 판매 이용정책 동의 처리 */
  createStoreAndAgreement: CreateStoreAndAgreementResult;
  /**  최초 입점신청 진입 시 (이탈 시 작성 유도 알림용) */
  createStoreDraft?: Maybe<Scalars['Boolean']['output']>;
  createStoreOrder?: Maybe<OrderResult>;
  /** 후기 작성. 주문 단위 1건, 구매자가 상품 수령 완료 후 수정 가능 기간 내에 가능. */
  createStoreProfileReview: CreateStoreProfileReviewResult;
  /** 사장님 답글 작성. 후기 1건당 답글 1건, 해당 비즈프로필 판매자만 가능. */
  createStoreProfileReviewComment: CreateStoreProfileReviewCommentResult;
  createStoreV2?: Maybe<Store>;
  /**  최신 검색 키워드 삭제 */
  deleteAllSearchKeyword?: Maybe<DeleteAllSearchKeywordResponse>;
  /**  관심 삭제 */
  deleteBookmark?: Maybe<Product>;
  deleteDeliveryAddress: DeleteDeliveryAddressResponse;
  /** 문의하기 글 삭제 */
  deleteInquiry: DeleteInquiryResult;
  deleteLatestSearchKeyword?: Maybe<DeleteLatestSearchKeywordResponse>;
  deleteOrderInvoice?: Maybe<OrderSheet>;
  /**  상품 삭제 */
  deleteProduct?: Maybe<Product>;
  deleteQna: Scalars['Boolean']['output'];
  /**  리뷰 */
  deleteReview?: Maybe<Review>;
  deleteReviewComment?: Maybe<Review>;
  /** 후기 삭제 (soft-delete). 작성자 본인만 가능, 삭제 후 재작성 허용. */
  deleteStoreProfileReview: DeleteStoreProfileReviewResult;
  /** 사장님 답글 삭제. 본인 BA 가 달아놓은 답글만. */
  deleteStoreProfileReviewComment: DeleteStoreProfileReviewCommentResult;
  followBizAccount?: Maybe<BusinessAccount>;
  /** 캠페인 쿠폰 발급 */
  issueCampaignCoupon: IssueCampaignCouponResult;
  /** 쿠폰 발급 */
  issueCoupon: IssueCouponResult;
  likeReview: Review;
  likeReview2: ReviewCommon;
  preparePayment: PreparePaymentResponse;
  /** 후기 리액션 등록. 같은 (review, user, reactionType) 조합은 한 번만. */
  reactToStoreProfileReview: ReactToStoreProfileReviewResult;
  registerRepresentProducts: Array<Maybe<Product>>;
  /** 판매자에게 채팅 주문 요청 */
  requestChatOrder: RequestChatOrderToSellerResult;
  requestCurationAlarm: CurationAlarmReceiver;
  requestStoreAlarm?: Maybe<BusinessAccount>;
  requestStoreAlarmByUser?: Maybe<StoreRequestAlarm>;
  /**  테스트용: 배송 상태 롤백 */
  rollbackDelivery: OrderSheet;
  saveBusinessAccountSettlement?: Maybe<BusinessAccount>;
  saveCart: SaveCartResponse;
  setBizNotificationLevel?: Maybe<BusinessAccount>;
  /**  배송 시작 */
  startDelivery: StartDeliveryResponse;
  startDeliveryV2?: Maybe<StartDeliveryResponse>;
  /** 캠페인 알림 구독 (마케팅 수신 동의 포함) */
  subscribeCampaign: SubscribeCampaignResult;
  /** 스토어 구독 (알림 받기) */
  subscribeStore?: Maybe<Store>;
  sympathy: Scalars['Boolean']['output'];
  undoLikeReview: Review;
  undoLikeReview2: ReviewCommon;
  unfollowBizAccount?: Maybe<BusinessAccount>;
  /** 캠페인 알림 구독 해제 (마케팅 수신 철회 포함) */
  unsubscribeCampaign: UnsubscribeCampaignResult;
  /** 스토어 구독 해제 (알림 받기 해제) */
  unsubscribeStore?: Maybe<Store>;
  /**  테스트용: 주문 상세 확인 롤백 */
  unvisitOrder: OrderSheet;
  updateDefaultDeliveryAddress: UpdateDefaultDeliveryAddressResponse;
  /** 문의하기 글 수정 */
  updateInquiry: UpdateInquiryResult;
  /**  상품 수정 */
  updateProduct?: Maybe<Product>;
  /**  상품 상태 수정 */
  updateProductStatus?: Maybe<Product>;
  updateReviewComment?: Maybe<Review>;
  /** 스토어 커버 이미지 업데이트 (스토어프로필 전용, 판매자만 가능) */
  updateStoreCoverImages: UpdateStoreCoverImagesResult;
  /**
   *  스토어 배송비 정책 변경
   * @deprecated No longer supported
   */
  updateStoreDelivery?: Maybe<Store>;
  updateStoreDeliverySetting?: Maybe<Store>;
  /**  스토어 최소주문 금액 변경 */
  updateStoreMinConditionPrice?: Maybe<Store>;
  /** 후기 수정. 작성자 본인 + 결제 완료 후 3 개월 이내. */
  updateStoreProfileReview: UpdateStoreProfileReviewResult;
  /** 사장님 답글 수정. 본인 BA 가 달아놓은 답글만. */
  updateStoreProfileReviewComment: UpdateStoreProfileReviewCommentResult;
  /**  주문 상세 확인 시 */
  visitOrder: OrderSheet;
  writeQna: Scalars['Boolean']['output'];
};


export type MutationAcceptOrderArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationAddCartPayloadArgs = {
  input: CartPayloadInput;
};


export type MutationAgreeToOriginInputResponsibilityArgs = {
  input: AgreeToOriginInputResponsibilityInput;
};


export type MutationAgreeToStoreProductSaleArgs = {
  input: AgreeToStoreProductSaleInput;
};


export type MutationApprovePaymentArgs = {
  input: ApprovePaymentInput;
};


export type MutationCancelCurationAlarmArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  cancelOrderInput: CancelOrderInput;
  role: Role;
};


export type MutationCancelOrderV2Args = {
  cancelOrderInput: CancelOrderInput;
  role: Role;
};


export type MutationCancelStoreProfileReviewReactionArgs = {
  input: CancelStoreProfileReviewReactionInput;
};


export type MutationChangeOrderInvoiceArgs = {
  company: DeliveryCompany;
  invoice: Scalars['String']['input'];
  storeOrderId: Scalars['ID']['input'];
};


export type MutationClickProductInquiryArgs = {
  inquiryType: ProductInquiryType;
  productId: Scalars['ID']['input'];
};


export type MutationCompleteDeliveryArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationConfirmPurchaseArgs = {
  confirmPurchaseInput: ConfirmPurchaseInput;
  role?: Role;
};


export type MutationCreateBookmarkArgs = {
  input: CreateBookmarkInput;
};


export type MutationCreateChatStoreOrderArgs = {
  input: CreateChatStoreOrderInput;
};


export type MutationCreateDeliveryAddressArgs = {
  input: CreateDeliveryAddressInput;
};


export type MutationCreateInquiryArgs = {
  input: CreateProductInquiryInput;
};


export type MutationCreateInquiryAnswerArgs = {
  input: CreateProductInquiryAnswerInput;
  role: Role;
};


export type MutationCreatePayAuthCodeArgs = {
  deviceId: Scalars['ID']['input'];
};


export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateReviewCommentArgs = {
  input: CreateReviewCommentInput;
};


export type MutationCreateStoreAndAgreementArgs = {
  input: CreateStoreAndAgreementRequestInput;
};


export type MutationCreateStoreOrderArgs = {
  createStoreOrderInput: CreateStoreOrderInput;
};


export type MutationCreateStoreProfileReviewArgs = {
  input: CreateStoreProfileReviewInput;
};


export type MutationCreateStoreProfileReviewCommentArgs = {
  input: CreateStoreProfileReviewCommentInput;
};


export type MutationCreateStoreV2Args = {
  createStoreRequestInput: CreateStoreRequestV2Input;
};


export type MutationDeleteBookmarkArgs = {
  input: DeleteBookmarkInput;
};


export type MutationDeleteDeliveryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInquiryArgs = {
  input: DeleteProductInquiryInput;
  role: Role;
};


export type MutationDeleteLatestSearchKeywordArgs = {
  input: DeleteLatestSearchKeywordInput;
};


export type MutationDeleteOrderInvoiceArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationDeleteQnaArgs = {
  qna?: InputMaybe<QuestionAndAnswerInput>;
};


export type MutationDeleteReviewArgs = {
  input?: InputMaybe<DeleteReviewInput>;
};


export type MutationDeleteReviewCommentArgs = {
  input: DeleteReviewCommentInput;
};


export type MutationDeleteStoreProfileReviewArgs = {
  input: DeleteStoreProfileReviewInput;
};


export type MutationDeleteStoreProfileReviewCommentArgs = {
  input: DeleteStoreProfileReviewCommentInput;
};


export type MutationFollowBizAccountArgs = {
  baId: Scalars['ID']['input'];
};


export type MutationIssueCampaignCouponArgs = {
  input: IssueCampaignCouponInput;
};


export type MutationIssueCouponArgs = {
  input: IssueCouponInput;
};


export type MutationLikeReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLikeReview2Args = {
  id: Scalars['ID']['input'];
};


export type MutationPreparePaymentArgs = {
  input: PreparePaymentInput;
};


export type MutationReactToStoreProfileReviewArgs = {
  input: ReactToStoreProfileReviewInput;
};


export type MutationRegisterRepresentProductsArgs = {
  input: RegisterRepresentProductsInput;
};


export type MutationRequestChatOrderArgs = {
  input: RequestChatOrderToSellerInput;
};


export type MutationRequestCurationAlarmArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRequestStoreAlarmArgs = {
  input: RequestStoreAlarmInput;
};


export type MutationRollbackDeliveryArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationSaveBusinessAccountSettlementArgs = {
  baId: Scalars['ID']['input'];
  input: SaveBusinessAccountSettlementInput;
};


export type MutationSaveCartArgs = {
  input: SaveCartInput;
};


export type MutationSetBizNotificationLevelArgs = {
  baId: Scalars['ID']['input'];
  level: NotificationLevel;
};


export type MutationStartDeliveryArgs = {
  company?: InputMaybe<DeliveryCompany>;
  invoice?: InputMaybe<Scalars['String']['input']>;
  storeOrderId: Scalars['ID']['input'];
};


export type MutationStartDeliveryV2Args = {
  company?: InputMaybe<DeliveryCompany>;
  invoice?: InputMaybe<Scalars['String']['input']>;
  storeOrderId: Scalars['ID']['input'];
};


export type MutationSubscribeCampaignArgs = {
  input: SubscribeCampaignInput;
};


export type MutationSubscribeStoreArgs = {
  storeId: Scalars['ID']['input'];
};


export type MutationSympathyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUndoLikeReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUndoLikeReview2Args = {
  id: Scalars['ID']['input'];
};


export type MutationUnfollowBizAccountArgs = {
  baId: Scalars['ID']['input'];
};


export type MutationUnsubscribeCampaignArgs = {
  input: UnsubscribeCampaignInput;
};


export type MutationUnsubscribeStoreArgs = {
  storeId: Scalars['ID']['input'];
};


export type MutationUnvisitOrderArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationUpdateDefaultDeliveryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateInquiryArgs = {
  input: UpdateProductInquiryInput;
  role: Role;
};


export type MutationUpdateProductArgs = {
  productId: Scalars['ID']['input'];
  updateProductInput?: InputMaybe<UpdateProductInput>;
};


export type MutationUpdateProductStatusArgs = {
  productId: Scalars['ID']['input'];
  status: ProductStatus;
};


export type MutationUpdateReviewCommentArgs = {
  input: UpdateReviewCommentInput;
};


export type MutationUpdateStoreCoverImagesArgs = {
  input: UpdateStoreCoverImagesInput;
};


export type MutationUpdateStoreDeliveryArgs = {
  input: UpdateStoreDeliveryInput;
};


export type MutationUpdateStoreDeliverySettingArgs = {
  input: UpdateStoreDeliverySettingInput;
};


export type MutationUpdateStoreMinConditionPriceArgs = {
  input: UpdateStoreMinConditionPriceInput;
};


export type MutationUpdateStoreProfileReviewArgs = {
  input: UpdateStoreProfileReviewInput;
};


export type MutationUpdateStoreProfileReviewCommentArgs = {
  input: UpdateStoreProfileReviewCommentInput;
};


export type MutationVisitOrderArgs = {
  storeOrderId: Scalars['ID']['input'];
};


export type MutationWriteQnaArgs = {
  qna?: InputMaybe<QuestionAndAnswerInput>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

/** 상품을 찾을 수 없음 */
export type NotFoundProduct = {
  __typename?: 'NotFoundProduct';
  message: Scalars['String']['output'];
};

/** 답글이 존재하지 않을 때 (update / delete comment). */
export type NotFoundStoreProfileReviewCommentError = {
  __typename?: 'NotFoundStoreProfileReviewCommentError';
  message: Scalars['String']['output'];
};

/** 대상 후기가 없거나 이미 삭제되었을 때 (update / delete / react / cancelReaction / comment 계열). */
export type NotFoundStoreProfileReviewError = {
  __typename?: 'NotFoundStoreProfileReviewError';
  message: Scalars['String']['output'];
};

/** 취소하려는 리액션이 존재하지 않을 때. cancelReaction 에서만 발생. */
export type NotFoundStoreProfileReviewReactionError = {
  __typename?: 'NotFoundStoreProfileReviewReactionError';
  message: Scalars['String']['output'];
};

export enum NotificationLevel {
  Alarm = 'ALARM',
  /**  Both PUSH and ACTIVITY with personalized content */
  Off = 'OFF',
  /**  Only ACTIVITY */
  PersonalizedAlarm = 'PERSONALIZED_ALARM',
  /**  Both PUSH and ACTIVITY */
  Snooze = 'SNOOZE'
}

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  page?: Maybe<Scalars['Int']['output']>;
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum OpenAlarmRequestAbilityStatus {
  /**  사전 알람 신청 가능 */
  AlarmRequested = 'ALARM_REQUESTED',
  Available = 'AVAILABLE',
  /**  사전 알람 신청 중 */
  UnavailableRegion = 'UNAVAILABLE_REGION'
}

export type Order = Node & {
  __typename?: 'Order';
  _id: Scalars['ID']['output'];
  buyer: Buyer;
  /**  해당 주문 상세에 방문한 적 있는지 */
  createdAt: Scalars['DateTime']['output'];
  /**  CM-690 해당 상품에 남길 수 있는 리뷰 태그 */
  delivery?: Maybe<DeliveryInfo>;
  detail?: Maybe<OrderDetail>;
  id: Scalars['ID']['output'];
  product: OrderProduct;
  /** 주문 상품 V2 */
  productV2: OrderProductV2;
  review?: Maybe<Review>;
  /**  해당 주문의 리뷰, nullable */
  reviewTags: Array<ReviewTag>;
  selectedOptions: Array<SelectedOptionSet>;
  store: OrderStore;
  /** 이 주문에 대해 구매자가 작성한 활성 후기. 작성 전이거나 삭제 상태면 null. */
  storeProfileReview?: Maybe<StoreProfileReview>;
  totalQuantity: Scalars['Int']['output'];
  visited: Scalars['Boolean']['output'];
};


export type OrderDetailArgs = {
  role: Role;
};

export enum OrderCanceledBy {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

/** 주문 출처 유형 */
export enum OrderChannelType {
  /** 채팅 주문 (채팅 내 결제 요청) */
  Chat = 'CHAT',
  /** 상품 주문 (스토어 상품 기반) */
  Default = 'DEFAULT'
}

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrderDeliveryTracking = Node & {
  __typename?: 'OrderDeliveryTracking';
  company: DeliveryCompany;
  detailPageScheme: Scalars['String']['output'];
  detailPageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice: Scalars['String']['output'];
};

export type OrderDetail = {
  __typename?: 'OrderDetail';
  _id: Scalars['ID']['output'];
  cancelInfo?: Maybe<CancelInfo>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /**  order status about payment, confirmed */
  payment: Payment;
  purchaseConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrderStatus;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['ID']['output'];
  node: Order;
};

/** 주문 조회 필터 */
export type OrderFilter = {
  /** 주문 채널 (DEFAULT: 일반 주문, CHAT: 채팅 주문) */
  channel?: InputMaybe<OrderChannelType>;
  /** 주문 상태 */
  statuses?: InputMaybe<Array<OrderStatus>>;
  /** 주문번호 (storeOrderId) */
  storeOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalProduct: Product;
  originalProductId: Scalars['ID']['output'];
  price: Money;
  productType: Type;
  receiveMethod?: Maybe<ReceiveMethod>;
  thumbnails: Array<Image>;
};

export type OrderProductMultiOptionSet = OrderProductOptionSet & {
  __typename?: 'OrderProductMultiOptionSet';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options: Array<ProductOptionValue>;
  price: Money;
  status: ProductOptionSetStatus;
};

export type OrderProductOptionSet = {
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  price: Money;
  status: ProductOptionSetStatus;
};

export type OrderProductSelfOptionSet = OrderProductOptionSet & {
  __typename?: 'OrderProductSelfOptionSet';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  price: Money;
  status: ProductOptionSetStatus;
};

/** 주문 상품 */
export type OrderProductSource = CustomProductSource | OriginalProductSource;

/** 주문 상품 V2 */
export type OrderProductV2 = {
  __typename?: 'OrderProductV2';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Money;
  productSource: OrderProductSource;
  productType: Type;
  receiveMethod?: Maybe<ReceiveMethod>;
  thumbnails: Array<Image>;
};

export type OrderResult = {
  __typename?: 'OrderResult';
  allowedOrigin: Scalars['String']['output'];
  appSecret: Scalars['String']['output'];
  body: OrderSheet;
  callbackUrl: Scalars['String']['output'];
  checkoutId: Scalars['String']['output'];
};

export type OrderSheet = Node & {
  __typename?: 'OrderSheet';
  /**  storeOrderId */
  _id: Scalars['ID']['output'];
  body: StoreOrder;
  buyer: Buyer;
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  deliveryTracking?: Maybe<OrderDeliveryTracking>;
  id: Scalars['ID']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  /**  order sheet subTitle */
  subTitle: Scalars['String']['output'];
  /**  order sheet title */
  title: Scalars['String']['output'];
  visited: Scalars['Boolean']['output'];
};


export type OrderSheetCanCancelArgs = {
  role: Role;
};

export type OrderSheetConnection = {
  __typename?: 'OrderSheetConnection';
  edges: Array<OrderSheetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrderSheetEdge = {
  __typename?: 'OrderSheetEdge';
  cursor: Scalars['ID']['output'];
  node: OrderSheet;
};

export type OrderSheetOffsetPagination = {
  __typename?: 'OrderSheetOffsetPagination';
  nodes: Array<OrderSheet>;
  pageInfo: OffsetPageInfo;
};

export enum OrderStatus {
  OrderAccepted = 'ORDER_ACCEPTED',
  OrderCanceled = 'ORDER_CANCELED',
  OrderPending = 'ORDER_PENDING',
  PaymentCompleted = 'PAYMENT_COMPLETED',
  PaymentPending = 'PAYMENT_PENDING',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED'
}

export type OrderStore = {
  __typename?: 'OrderStore';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalStore?: Maybe<Store>;
  originalStoreId: Scalars['ID']['output'];
};

/** 주문 요약 조회 필터 */
export type OrderSummaryFilter = {
  /** 주문 채널 (DEFAULT: 일반 주문, CHAT: 채팅 주문) */
  channel?: InputMaybe<OrderChannelType>;
};

export type OrdersByStatus = {
  __typename?: 'OrdersByStatus';
  currentOrderCount: Scalars['Int']['output'];
  orders: OrderSheetConnection;
  pastOrderCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};


export type OrdersByStatusOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OriginalProductSource = {
  __typename?: 'OriginalProductSource';
  originalProduct: Product;
  originalProductId: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

/** 부모 문의를 찾을 수 없음 */
export type ParentInquiryNotFound = {
  __typename?: 'ParentInquiryNotFound';
  message: Scalars['String']['output'];
};

export type PayAuthCode = {
  __typename?: 'PayAuthCode';
  value: Scalars['String']['output'];
};

export type Payment = {
  /**  쿠폰 할인 */
  couponDiscountAmount?: Maybe<Money>;
  /**  배송비 */
  deliveryFee?: Maybe<Money>;
  /**  할인 총합 */
  discountAmount: Money;
  /**  주문금액 */
  orderAmount: Money;
  /**  총 결제금액 */
  paymentAmount: Money;
  /**  상품 할인 */
  productDiscountAmount?: Maybe<Money>;
};

export enum PaymentMethod {
  Card = 'CARD',
  /**  간편결제 */
  DaangnMoney = 'DAANGN_MONEY',
  None = 'NONE',
  /**  당근머니 */
  Point = 'POINT',
  /**  계좌이체 */
  SimpleCard = 'SIMPLE_CARD',
  /**  일반결제 */
  Vba = 'VBA'
}

/**
 * 다른 결제수단으로 재시도 가능한 결제 에러.
 * 클라이언트는 결제창을 닫지 않고 사용자에게 다른 결제수단을 선택하도록 안내한다.
 */
export type PaymentPassThroughError = {
  __typename?: 'PaymentPassThroughError';
  /** 참고) 에러 타입 범위가 광범위하고, pay 서비스 code를 의존하기 때문에 string으로 처리해요 */
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum PaymentType {
  Store = 'STORE',
  Storechat = 'STORECHAT',
  Storeprofile = 'STOREPROFILE'
}

export type PendingPayment = Payment & {
  __typename?: 'PendingPayment';
  /**  쿠폰 할인 */
  couponDiscountAmount?: Maybe<Money>;
  /**  배송비 */
  deliveryFee?: Maybe<Money>;
  /**  할인 총합 */
  discountAmount: Money;
  /**  주문금액 */
  orderAmount: Money;
  /**  총 결제금액 */
  paymentAmount: Money;
  /**  상품 할인 */
  productDiscountAmount?: Maybe<Money>;
};

export type PointLocation = Location & {
  __typename?: 'PointLocation';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<LocationType>;
};

export type PostWrapperForProduceHomeFeed = Node & {
  __typename?: 'PostWrapperForProduceHomeFeed';
  id: Scalars['ID']['output'];
  post: ProducePost;
};

export type PostWrapperForSearch = Node & {
  __typename?: 'PostWrapperForSearch';
  id: Scalars['ID']['output'];
  post: ProducePost;
};

export type PreparePaymentInput = {
  checkoutId: Scalars['ID']['input'];
  customerInfo?: InputMaybe<CustomerInfoInput>;
  deliveryAddressId?: InputMaybe<Scalars['ID']['input']>;
  deliveryRequirements?: InputMaybe<DeliveryRequirementInput>;
  discounts?: InputMaybe<Array<DiscountInput>>;
  totalPrice?: InputMaybe<MoneyInput>;
};

export type PreparePaymentResponse = {
  __typename?: 'PreparePaymentResponse';
  payAppSecret: Scalars['String']['output'];
  payId: Scalars['ID']['output'];
  paymentType: PaymentType;
  referrer?: Maybe<Scalars['String']['output']>;
  webviewVersion?: Maybe<WebviewVersion>;
};

export type ProduceHome = Node & {
  __typename?: 'ProduceHome';
  chips?: Maybe<Array<Chip>>;
  curation?: Maybe<Curation>;
  id: Scalars['ID']['output'];
  produceHomeFeed: ProduceHomeFeedConnection;
  producePosts?: Maybe<ProducePostConnection>;
  products: ProductConnection;
  surveyBanner?: Maybe<SurveyBanner>;
};


export type ProduceHomeProduceHomeFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ProduceHomeProducePostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ProduceHomeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  chipId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ProduceHomeFeed = {
  __typename?: 'ProduceHomeFeed';
  content: Content;
  id: Scalars['ID']['output'];
};

export type ProduceHomeFeedConnection = {
  __typename?: 'ProduceHomeFeedConnection';
  edges: Array<ProduceHomeFeedEdge>;
  pageInfo: PageInfo;
};

export type ProduceHomeFeedEdge = {
  __typename?: 'ProduceHomeFeedEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProduceHomeFeed>;
};

export type ProducePost = Node & {
  __typename?: 'ProducePost';
  _id: Scalars['ID']['output'];
  bookmarkCount: Scalars['Long']['output'];
  chatRoomCount: Scalars['Long']['output'];
  couponId?: Maybe<Scalars['String']['output']>;
  /**  가격 정보가 없는 농수산물 게시물이 있음 */
  createdAt: Scalars['DateTime']['output'];
  firstImage: Image;
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Long']['output']>;
  products: Array<Product>;
  region: Region;
  targetUri: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProducePostConnection = {
  __typename?: 'ProducePostConnection';
  edges: Array<ProducePostEdge>;
  pageInfo: PageInfo;
};

export type ProducePostEdge = {
  __typename?: 'ProducePostEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProducePost>;
};

export type Product = Node & {
  __typename?: 'Product';
  /**  product local id */
  _id: Scalars['ID']['output'];
  /**  product deleted or not */
  deleted: Scalars['Boolean']['output'];
  detail?: Maybe<ProductDetail>;
  /**  product global id */
  id: Scalars['ID']['output'];
  /** 상품 상세에서 보여줄 후기 요약 통계. */
  storeProfileReviewStats: StoreProfileReviewStats;
  /** 상품 단위 후기 리스트 (커서 페이지네이션). */
  storeProfileReviews: StoreProfileReviewConnection;
};


export type ProductStoreProfileReviewsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<StoreProfileReviewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StoreProfileReviewSort>;
};

export type ProductAdditionalFields = DeliveryProductAdditionalFields | GoodsAdditionalFields | ServiceAdditionalFields | VoucherProductAdditionalFields | VoucherTicketProductAdditionalFields;

export type ProductAttributeInput = {
  dataKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  _id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  children?: Maybe<Array<ProductCategory>>;
  depth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLeaf: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  edges: Array<ProductCategoryEdge>;
  pageInfo: PageInfo;
};

export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  cursor: Scalars['ID']['output'];
  node: ProductCategory;
};

export type ProductCombiOption = Node & ProductOptionSet & {
  __typename?: 'ProductCombiOption';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options: Array<ProductOptionValue>;
  price: Money;
  sold: Scalars['Int']['output'];
  status: ProductOptionSetStatus;
  stock: Scalars['Int']['output'];
  stockFree: Scalars['Boolean']['output'];
};

export type ProductCombiOptionGroup = {
  __typename?: 'ProductCombiOptionGroup';
  /**  0인 경우 구매 불가, n인 경우 n개만 최대 노출, null인 경우 무제한 */
  availableMaxQuantity?: Maybe<Scalars['Int']['output']>;
  options: Array<ProductOption>;
  sets: Array<ProductCombiOption>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductCurationComponent = CurationComponent & Node & {
  __typename?: 'ProductCurationComponent';
  id: Scalars['ID']['output'];
  moreButton?: Maybe<CurationComponentMoreButton>;
  products: ProductConnection;
  title?: Maybe<Scalars['String']['output']>;
  uiType: ProductCurationComponentUiType;
};


export type ProductCurationComponentProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductCurationComponentUiType {
  HorizontalList = 'HORIZONTAL_LIST',
  OneGrid = 'ONE_GRID'
}

export type ProductCustomer = {
  __typename?: 'ProductCustomer';
  name: Scalars['String']['output'];
  profile?: Maybe<Image>;
};

export type ProductCustomerInfo = {
  __typename?: 'ProductCustomerInfo';
  customerPurchaseCount: Scalars['Int']['output'];
  latestCustomers?: Maybe<Array<Maybe<ProductCustomer>>>;
};

export type ProductDeliverySetting = {
  __typename?: 'ProductDeliverySetting';
  arrivalGuaranteeDay?: Maybe<Scalars['Int']['output']>;
  expectedShippingDays?: Maybe<Scalars['Int']['output']>;
  remoteAreaAdditionalFee?: Maybe<RemoteAreaAdditionalFee>;
  restrictedRegions: Array<ShippingRestrictionRegion>;
  sameDayShippingCutoffTime?: Maybe<Scalars['Int']['output']>;
};

export type ProductDeliverySettingInput = {
  expectedShippingDays?: InputMaybe<Scalars['Int']['input']>;
  remoteAreaAdditionalFee?: InputMaybe<RemoteAreaAdditionalFeeInput>;
  restrictedRegions?: InputMaybe<Array<ShippingRestrictionRegion>>;
  sameDayShippingCutoffTime?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  /**  product local id */
  _id: Scalars['ID']['output'];
  additionalFields: ProductAdditionalFields;
  benefit?: Maybe<Scalars['String']['output']>;
  cartAddable: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  customers: ProductCustomerInfo;
  /**
   *  discount, it equals with price minus salePrice
   *  use productDiscount instead
   * @deprecated No longer supported
   */
  discount?: Maybe<Money>;
  discountInfo?: Maybe<ProductDiscountInfo>;
  displayRegion?: Maybe<Scalars['String']['output']>;
  form: ProductForm;
  inquiries: ProductInquiryConnection;
  /**  duration in second, two days default if duration not provided */
  latestUniqueViewCount: Scalars['Long']['output'];
  minConditionPrice?: Maybe<Money>;
  myFeedback: Feedback;
  /**  product name */
  name: Scalars['String']['output'];
  official: Scalars['Boolean']['output'];
  optionGroup: ProductOptionSetGroup;
  outOfStock: Scalars['Boolean']['output'];
  platformPolicy?: Maybe<ProductPlatformPolicy>;
  /**  original price */
  price: Money;
  productAttributes: Array<Attribute>;
  productDisplay: ProductDisplay;
  productType: Type;
  purchasePolicy: Array<Attribute>;
  /**  how to receive product */
  receiveMethods: Array<ReceiveMethod>;
  recommendedReviewTotalCount: Scalars['Int']['output'];
  refundExchangePolicy: Array<Attribute>;
  represent?: Maybe<RepresentProduct>;
  /** 만족도(%) (0 ~ 100) */
  reviewSatisfiedRate: Scalars['Float']['output'];
  /** 리뷰 평균 별점 */
  reviewStarRatingAverage: Scalars['Float']['output'];
  /** 리뷰 총 개수 */
  reviewTotalCount: Scalars['Int']['output'];
  /** 상품 리뷰 총 개수(상품 후기만 포함, 포토리뷰 등 기타 리뷰 제외) */
  reviewTotalCountExcludeProduct: Scalars['Int']['output'];
  reviewable: Reviewable;
  reviews?: Maybe<ReviewConnection>;
  /**  produtSale id */
  saleId: Scalars['ID']['output'];
  /**  sale price which will be charged to buyer */
  salePrice: Money;
  shareScheme: Scalars['String']['output'];
  /**  accumulated sold product count */
  sold?: Maybe<Scalars['Int']['output']>;
  status: ProductStatus;
  /**  remaining product count */
  stock?: Maybe<Scalars['Int']['output']>;
  stockFree: Scalars['Boolean']['output'];
  /**  product store */
  store: Store;
  /**
   *  판매자 정보
   *  스토어 사업자 정보 (상호명, 대표자명, 사업자 주, 사업자 등록번호 등)
   */
  storeAttributes: Array<Attribute>;
  storeId: Scalars['ID']['output'];
  taxType: TaxType;
  templates: Array<TemplateItem>;
  thumbnailImages: Array<ProductImage>;
  /**
   *  product thumbnail images
   * @deprecated use thumbnailImages field instead
   */
  thumbnails: Array<Image>;
  title: Scalars['String']['output'];
  type: ProductType;
  /**  현재 상품을 보고 있는 유저들의 정보 */
  viewer: ProductUniqueViewerInfo;
};


export type ProductDetailInquiriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProductInquiryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDetailLatestUniqueViewCountArgs = {
  duration?: InputMaybe<Scalars['Long']['input']>;
};


export type ProductDetailReviewsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReviewSort>;
};

export type ProductDiscountInfo = {
  __typename?: 'ProductDiscountInfo';
  discountAmount?: Maybe<Money>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductDisplay = {
  __typename?: 'ProductDisplay';
  type: ProductDisplayType;
};

export enum ProductDisplayType {
  Inhouse = 'INHOUSE',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['ID']['output'];
  node: Product;
};

export type ProductFilter = {
  /**  INHOUSE 상품은 웬만한 케이스에서 노출되면 안되기 때문에 filter 필드를 사용할 때 꼭 displays 에 [PUBLIC, PRIVATE] 을 채워주세요 */
  displays?: InputMaybe<Array<ProductDisplayType>>;
  productType?: InputMaybe<Type>;
  representStatus?: InputMaybe<RepresentStatus>;
  statuses?: InputMaybe<Array<ProductStatus>>;
};

export type ProductForm = {
  __typename?: 'ProductForm';
  /**  대분류, 중분류, 소분류 순 */
  categories: Array<ProductCategory>;
  /**  content output */
  content: Scalars['String']['output'];
  discountExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  price: Money;
  productAttributeInputGroup: InputGroup;
  productTemplatesInputGroup: InputGroup;
  /**  salePrice가 없으면 할인 판매하기 안 함 */
  salePrice?: Maybe<Money>;
  simpleOptions?: Maybe<Array<SimpleOption>>;
  stock?: Maybe<Scalars['Int']['output']>;
  /**  stockFree가 있으면 재고 수량 설정 안 함 */
  stockFree: Scalars['Boolean']['output'];
  thumbnailImages: Array<ProductImage>;
  /** @deprecated Use thumbnailImages instead */
  thumbnails: Array<Image>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  _id: Scalars['ID']['output'];
  height: Scalars['Int']['output'];
  medium: Scalars['String']['output'];
  pdpThumbnail: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** 상품 문의하기 */
export type ProductInquiry = Node & {
  __typename?: 'ProductInquiry';
  _id: Scalars['ID']['output'];
  /** 답변 */
  answer: Array<Maybe<ProductInquiry>>;
  /** 내용 */
  content: Scalars['String']['output'];
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 숨김처리 여부 */
  isSecret: Scalars['Boolean']['output'];
  /** 부모 문의 ID */
  parentInquiryId?: Maybe<Scalars['ID']['output']>;
  /** 상품 상세 정보 */
  productDetail?: Maybe<ProductDetail>;
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output'];
  /** 작성자 */
  writer: InquiryWriter;
};

export type ProductInquiryConnection = {
  __typename?: 'ProductInquiryConnection';
  edges: Array<ProductInquiryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductInquiryEdge = {
  __typename?: 'ProductInquiryEdge';
  cursor: Scalars['ID']['output'];
  node: ProductInquiry;
};

export type ProductInquiryFilter = {
  /** 비밀글 제외 (true: 비밀글 제외, false/null: 전체) */
  excludeSecret?: InputMaybe<Scalars['Boolean']['input']>;
  /** 내 문의글만 보기 (true: 내 문의글만, false/null: 전체) */
  isMine?: InputMaybe<Scalars['Boolean']['input']>;
  /** 정렬 방식 */
  sort?: InputMaybe<ProductInquirySort>;
};

/** 판매자용 상품 문의 필터 */
export type ProductInquiryFromSellerFilter = {
  /** 검색 키워드 (질문 내용 검색) */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** 상품 ID */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** 답변 상태 */
  status?: InputMaybe<AnswerStatus>;
};

/** 판매자용 상품 문의 페이지네이션 */
export type ProductInquiryOffsetPagination = {
  __typename?: 'ProductInquiryOffsetPagination';
  /** 문의 목록 */
  nodes: Array<ProductInquiry>;
  /** 페이지 정보 */
  pageInfo: OffsetPageInfo;
  /** 문의 통계 (전체/답변됨/미답변 개수) */
  stats: ProductInquiryStats;
};

export enum ProductInquirySort {
  /**  최신순 */
  Newest = 'NEWEST'
}

/** 상품 문의 통계 */
export type ProductInquiryStats = {
  __typename?: 'ProductInquiryStats';
  /** 답변된 문의 수 */
  answered: Scalars['Int']['output'];
  /** 전체 문의 수 */
  total: Scalars['Int']['output'];
  /** 미답변 문의 수 */
  unanswered: Scalars['Int']['output'];
};

export enum ProductInquiryType {
  Call = 'CALL',
  Chat = 'CHAT'
}

export type ProductOffsetPagination = {
  __typename?: 'ProductOffsetPagination';
  nodes: Array<Product>;
  pageInfo: OffsetPageInfo;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<ProductOptionValue>;
};

export type ProductOptionSet = {
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  price: Money;
  sold: Scalars['Int']['output'];
  status: ProductOptionSetStatus;
  stock: Scalars['Int']['output'];
  stockFree: Scalars['Boolean']['output'];
};

export type ProductOptionSetGroup = ProductCombiOptionGroup | ProductSelfOption;

export enum ProductOptionSetStatus {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  Inactive = 'INACTIVE',
  Rejected = 'REJECTED'
}

/**
 *  ProductOption 색상
 *  [ProductOptionValue!]! [빨강, 노랑, 파랑]
 */
export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
};

export type ProductPlatformPolicy = {
  __typename?: 'ProductPlatformPolicy';
  /** 구매자 주문 취소 차단 여부 (false: 취소 가능, true: 취소 불가) */
  blockBuyerOrderCancel: Scalars['Boolean']['output'];
  /** 직접 구매 차단 여부 (false: 구매 가능, true: 직접 구매 불가) */
  blockDirectPurchase: Scalars['Boolean']['output'];
  /** 제주/도서산간 추가 배송비 무료 여부 (true: 추가 배송비 0원) */
  freeRemoteDeliveryFee: Scalars['Boolean']['output'];
};

export type ProductSelfOption = Node & ProductOptionSet & {
  __typename?: 'ProductSelfOption';
  _id: Scalars['ID']['output'];
  /**  0인 경우 구매 불가, n인 경우 n개만 최대 노출, null인 경우 무제한 */
  availableMaxQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  price: Money;
  sold: Scalars['Int']['output'];
  status: ProductOptionSetStatus;
  stock: Scalars['Int']['output'];
  stockFree: Scalars['Boolean']['output'];
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ProductType {
  Delivery = 'DELIVERY',
  Voucher = 'VOUCHER',
  VoucherTicket = 'VOUCHER_TICKET'
}

export enum ProductTypeExperimentCase {
  Default = 'DEFAULT',
  VoucherTicket = 'VOUCHER_TICKET'
}

export type ProductUniqueViewerInfo = {
  __typename?: 'ProductUniqueViewerInfo';
  /** 가장 최근에 보고 있는 유저 프로필 */
  latestViewers: Array<ProductViewer>;
  /** 함께 보고 있는 유저 수 */
  viewerCount: Scalars['Long']['output'];
};


export type ProductUniqueViewerInfoLatestViewersArgs = {
  duration?: InputMaybe<Scalars['Long']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductUniqueViewerInfoViewerCountArgs = {
  duration?: InputMaybe<Scalars['Long']['input']>;
};

export type ProductViewer = {
  __typename?: 'ProductViewer';
  name: Scalars['String']['output'];
  profileUrl?: Maybe<Scalars['String']['output']>;
};

export type ProductWrapperForSearch = {
  __typename?: 'ProductWrapperForSearch';
  product: Product;
  regionName?: Maybe<Scalars['String']['output']>;
};

export type PromptStudioOptions = {
  /** prompt studio 버전. published 또는 숫자 버전 입력 가능. */
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum PurchaseCountType {
  Product = 'PRODUCT',
  Store = 'STORE'
}

export type Query = {
  __typename?: 'Query';
  /** 현재 활성화된 채팅 주문 정책 조회 */
  activeChatOrderPolicy?: Maybe<ChatOrderPolicy>;
  agroFisheryChips?: Maybe<Array<Chip>>;
  agroFisheryProducts: ProductConnection;
  /** prompt studio · llm 등 ai 요청 단일 진입점. */
  askAI: AskAiResult;
  availableBankList?: Maybe<Array<BankCodeName>>;
  baById?: Maybe<BusinessAccount>;
  batchProducts: Array<Product>;
  bulkDeliveryStartRequest?: Maybe<BulkDeliveryStartRequest>;
  /**  입점 프로세스 관련 api */
  businessAccount: BusinessAccount;
  /** 캠페인 그룹 조회 */
  campaignGroup?: Maybe<CampaignGroup>;
  carts: CartConnection;
  /**  사업자 등록 번호 유효성 체크 */
  checkBusinessRegistrationNo: Scalars['Boolean']['output'];
  checkBusinessStatus: BusinessStatusResult;
  /**  정산 정보 일치 체크 (은행, 예금주명, 계좌번호 일치 체크) */
  checkSettlement: AccountStatusResult;
  checkout?: Maybe<Checkout>;
  /**
   * 컬렉션 조회.
   * key는 CollectionProductKey enum의 name 값 사용 (대소문자 무관).
   * 예: PRICE_UNDER_20000, PRICE_20000, PRICE_30000_40000, PRICE_OVER_50000,
   * CATEGORY_STRAWBERRY, CATEGORY_TANGOR, CATEGORY_APPLE, CATEGORY_PEAR, CATEGORY_DRIED_PERSIMMON
   */
  collection?: Maybe<Collection>;
  collectionById?: Maybe<Collection>;
  /** 발급 가능한 쿠폰 템플릿 목록 조회 */
  couponTemplates: CouponTemplateConnection;
  curation?: Maybe<Curation>;
  curationAlarmByMe?: Maybe<CurationAlarmReceiver>;
  deliveryAddresses: DeliveryAddressConnection;
  /**  단일 피처플래그 조회 */
  featureFlag: FeatureFlag;
  /**  단일 피처플래그 조회 */
  featureFlagByName: FeatureFlagByName;
  /** @deprecated only for test */
  getCustomerInfo?: Maybe<CustomerInfo>;
  /** @deprecated only for test */
  getDeliveryAddresses: Array<DeliveryAddress>;
  getDepositAndConfirmInfoByDateRange: DepositAndConfirmInfoConnection;
  getDepositAndConfirmInfoById: DepositAndConfirmInfo;
  /**  Daily Query */
  getDepositSummary: DepositSummary;
  getSettlementConfirmDetails: SettlementConfirmDetailConnection;
  /** 기간 내 주문별 정산 상세 조회 (정산일, 주문 금액, 수수료 등) */
  getSettlementDetails: SettlementDetailConnection;
  getSettlementHistories: SettlementHistoryConnection;
  /**  Monthly Query */
  getSettlementSummary: SettlementSummary;
  hoianUserById?: Maybe<HoianUser>;
  image?: Maybe<Image>;
  images: Array<Image>;
  me?: Maybe<Me>;
  newAliceProductIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**  node query */
  node?: Maybe<Node>;
  /**  order by id */
  order?: Maybe<Order>;
  /**  orderSheet by id */
  orderSheet?: Maybe<OrderSheet>;
  produceHome: ProduceHome;
  /**  productDetail catalog by product id */
  product?: Maybe<Product>;
  productAttributeInputGroupByCategoryId: InputGroup;
  productAttributesByCategoryId: Array<Attribute>;
  productCategories: ProductCategoryConnection;
  /** 판매자 상품 문의 목록 조회 (Offset 기반 페이지네이션) */
  productInquiriesByOffset: ProductInquiryOffsetPagination;
  productTemplatesInputGroupByCategoryId: InputGroup;
  productsByRegionId: ProductConnection;
  questionAndAnswer: QuestionAndAnswer;
  recommendedProductList: Array<Product>;
  /** 추천 상품 목록. 필터 boolean 토글로 정렬/스코어링 축을 결합. */
  recommendedProducts: ProductConnection;
  reportOptions: Array<ReportOption>;
  /**  리뷰 */
  review?: Maybe<Review>;
  /**  가게 후기 */
  reviewsIncludeStoreReview?: Maybe<ReviewCommonConnection>;
  /**  기존에 등록된 사업자 등록 정보 불러오기 */
  savedBusinessRegistrationInfo?: Maybe<StoreRegistration>;
  seller?: Maybe<Seller>;
  /**  store by businessAcccount id */
  store?: Maybe<Store>;
  storeAlarmByUser?: Maybe<StoreRequestAlarm>;
  /**  store by id */
  storeById?: Maybe<Store>;
  storeHome: StoreHome;
  /** 특정 후기 단건 조회. */
  storeProfileReview?: Maybe<StoreProfileReview>;
  /** 비즈프로필 단위 후기 리스트. */
  storeProfileReviews: StoreProfileReviewConnection;
  /** 사장님센터용 후기 목록. 답글 유무 / 특정 고객 등 판매자 관점 필터 + offset 페이지네이션. */
  storeProfileReviewsByOffset: StoreProfileReviewOffsetPagination;
  /**  테마관 */
  theme?: Maybe<Theme>;
  useDpPayment: Scalars['Boolean']['output'];
  verticalSearch: VerticalSearch;
};


export type QueryAgroFisheryChipsArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryAgroFisheryProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  chipId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAskAiArgs = {
  data: AskAiDataInput;
};


export type QueryBaByIdArgs = {
  baId: Scalars['ID']['input'];
};


export type QueryBatchProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryBulkDeliveryStartRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryBusinessAccountArgs = {
  baId: Scalars['ID']['input'];
};


export type QueryCampaignGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCartsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckBusinessRegistrationNoArgs = {
  no: Scalars['String']['input'];
};


export type QueryCheckBusinessStatusArgs = {
  no: Scalars['String']['input'];
};


export type QueryCheckSettlementArgs = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
};


export type QueryCheckoutArgs = {
  checkoutId: Scalars['ID']['input'];
};


export type QueryCollectionArgs = {
  key: Scalars['String']['input'];
};


export type QueryCollectionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CouponTemplatesFilter;
};


export type QueryCurationArgs = {
  id: Scalars['ID']['input'];
  regionId?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryDeliveryAddressesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureFlagArgs = {
  name: FeatureFlagName;
};


export type QueryFeatureFlagByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetDepositAndConfirmInfoByDateRangeArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<SettlementFilter>;
  first: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryGetDepositAndConfirmInfoByIdArgs = {
  depositItemId: Scalars['ID']['input'];
};


export type QueryGetDepositSummaryArgs = {
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<SettlementFilter>;
  startDate: Scalars['Date']['input'];
};


export type QueryGetSettlementConfirmDetailsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  depositItemId: Scalars['ID']['input'];
  filter?: InputMaybe<SettlementFilter>;
  first: Scalars['Int']['input'];
};


export type QueryGetSettlementDetailsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<SettlementFilter>;
  first: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryGetSettlementHistoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  baId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  month: Scalars['String']['input'];
  year: Scalars['String']['input'];
};


export type QueryGetSettlementSummaryArgs = {
  baId: Scalars['ID']['input'];
  month: Scalars['String']['input'];
  year: Scalars['String']['input'];
};


export type QueryHoianUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrderSheetArgs = {
  orderSheetId: Scalars['ID']['input'];
  role?: InputMaybe<Role>;
};


export type QueryProduceHomeArgs = {
  regionId: Scalars['Long']['input'];
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
  status?: InputMaybe<ProductStatus>;
};


export type QueryProductAttributeInputGroupByCategoryIdArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryProductAttributesByCategoryIdArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Type>;
};


export type QueryProductInquiriesByOffsetArgs = {
  filter?: InputMaybe<ProductInquiryFromSellerFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductTemplatesInputGroupByCategoryIdArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryProductsByRegionIdArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
  sortType?: InputMaybe<SortType>;
};


export type QueryRecommendedProductListArgs = {
  actorId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
};


export type QueryRecommendedProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<RecommendedProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportOptionsArgs = {
  reporterType?: InputMaybe<ReporterType>;
  targetType?: InputMaybe<ReportTargetType>;
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewsIncludeStoreReviewArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
  sort?: InputMaybe<ReviewSort>;
};


export type QuerySavedBusinessRegistrationInfoArgs = {
  baId: Scalars['ID']['input'];
  registrationNumber: Scalars['String']['input'];
};


export type QueryStoreArgs = {
  baId: Scalars['ID']['input'];
};


export type QueryStoreByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoreProfileReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoreProfileReviewsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  baId: Scalars['ID']['input'];
  filter?: InputMaybe<StoreProfileReviewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StoreProfileReviewSort>;
};


export type QueryStoreProfileReviewsByOffsetArgs = {
  baId: Scalars['ID']['input'];
  filter?: InputMaybe<StoreProfileReviewSellerFilter>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  sort?: InputMaybe<StoreProfileReviewSellerSort>;
};


export type QueryThemeArgs = {
  id: Scalars['ID']['input'];
};

export type QuestionAndAnswer = {
  __typename?: 'QuestionAndAnswer';
  /**  List 는 전체 다 보여줘야하나ㅏ? */
  detail: QuestionAndAnswerNode;
  list?: Maybe<Array<QuestionAndAnswerNode>>;
};


export type QuestionAndAnswerDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QuestionAndAnswerListArgs = {
  after: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAndAnswerConnection = {
  __typename?: 'QuestionAndAnswerConnection';
  edges?: Maybe<Array<QuestionAndAnswerEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type QuestionAndAnswerEdge = {
  __typename?: 'QuestionAndAnswerEdge';
  cursor: Scalars['String']['output'];
  node: QuestionAndAnswerNode;
};

export type QuestionAndAnswerInput = {
  baId: Scalars['Long']['input'];
  content: Scalars['String']['input'];
  likeCount: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
  rootQuestionId?: InputMaybe<Scalars['Long']['input']>;
  type: Scalars['String']['input'];
  userId: Scalars['Long']['input'];
};

export type QuestionAndAnswerNode = Node & {
  __typename?: 'QuestionAndAnswerNode';
  baId: Scalars['Long']['output'];
  children?: Maybe<Array<QuestionAndAnswerNode>>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  like: Scalars['Int']['output'];
  rootQuestionId?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['Long']['output'];
};

/** 리액션 등록. 기본 HELPFUL. */
export type ReactToStoreProfileReviewInput = {
  reactionType?: StoreProfileReviewReactionType;
  reviewId: Scalars['ID']['input'];
};

export type ReactToStoreProfileReviewResult = {
  __typename?: 'ReactToStoreProfileReviewResult';
  error?: Maybe<ErrorReactToStoreProfileReview>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

export enum ReceiveMethod {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type RecentlyViewedProductConnection = {
  __typename?: 'RecentlyViewedProductConnection';
  edges: Array<RecentlyViewedProductEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecentlyViewedProductEdge = {
  __typename?: 'RecentlyViewedProductEdge';
  cursor: Scalars['ID']['output'];
  node: Product;
  viewedAt: Scalars['DateTime']['output'];
};

export type RecommendKeyword = {
  __typename?: 'RecommendKeyword';
  keyword: Scalars['String']['output'];
};

/** 추천 상품 필터. 모든 필드 default false (해당 축 미적용). */
export type RecommendedProductFilter = {
  /** 품질 점수 기반 필터링. */
  qualityScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** 최신성 기반 필터링. */
  recency?: InputMaybe<Scalars['Boolean']['input']>;
  /** 텍스트 관련성 (제목 / 카테고리 / 스토어명) 기반 필터링. */
  textRelevance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Region = {
  __typename?: 'Region';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  name4?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
};

export type RegisterRepresentProductPayloadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};

export type RegisterRepresentProductsInput = {
  payload: Array<RegisterRepresentProductPayloadInput>;
};

export enum RegistrationType {
  /**
   *  법인
   * @deprecated 사업자 타입이 아닌 과세 타입으로 변경(CM-706), 법인 사업자 -> 법인으로 취급
   */
  Cooperate = 'COOPERATE',
  /**  법인 */
  CooperatePayer = 'COOPERATE_PAYER',
  /**  일반 */
  GeneralTaxPayer = 'GENERAL_TAX_PAYER',
  /**  오기입시 재입점신청을 위한 값 */
  Invalid = 'INVALID',
  /**
   *  개인사업자
   * @deprecated 사업자 타입이 아닌 과세 타입으로 변경(CM-706), 개인사업자 -> 일반으로 취급
   */
  SelfEmployed = 'SELF_EMPLOYED',
  /**  간이 */
  SummaryTaxPayer = 'SUMMARY_TAX_PAYER',
  /**  면세 */
  TaxFreePayer = 'TAX_FREE_PAYER'
}

export type RejectInfo = {
  __typename?: 'RejectInfo';
  customReason?: Maybe<Scalars['String']['output']>;
  invalidInputFields: Array<Maybe<StoreRejectInvalidInputField>>;
  reason: StoreRejectReason;
  rejectedAt: Scalars['DateTime']['output'];
};

export type RemoteAreaAdditionalFee = {
  __typename?: 'RemoteAreaAdditionalFee';
  islandRemote?: Maybe<Money>;
  jeju?: Maybe<Money>;
};

export type RemoteAreaAdditionalFeeInput = {
  islandRemote?: InputMaybe<MoneyInput>;
  jeju?: InputMaybe<MoneyInput>;
};

export type Report = Node & {
  __typename?: 'Report';
  _id: Scalars['ID']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  reporterId: Scalars['ID']['output'];
  reporterType: ReporterType;
  targetId: Scalars['ID']['output'];
  targetType: ReportTargetType;
};

export type ReportOption = {
  __typename?: 'ReportOption';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum ReportTargetType {
  Order = 'ORDER',
  Product = 'PRODUCT',
  Review = 'REVIEW',
  Store = 'STORE',
  System = 'SYSTEM'
}

export enum ReporterType {
  BusinessAccountUser = 'BUSINESS_ACCOUNT_USER',
  User = 'USER'
}

export type RepresentProduct = {
  __typename?: 'RepresentProduct';
  description?: Maybe<Scalars['String']['output']>;
  status: RepresentStatus;
};

export type RepresentProductPolicy = {
  __typename?: 'RepresentProductPolicy';
  maxCount: Scalars['Int']['output'];
};

export enum RepresentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** 반복 요청 불가능 */
export type RequestChatOrderCooldownActive = {
  __typename?: 'RequestChatOrderCooldownActive';
  message: Scalars['String']['output'];
};

export type RequestChatOrderToSellerError = ChatOrderStoreNotFound | RequestChatOrderCooldownActive;

/**  ========== 채팅 주문 제안 ========== */
export type RequestChatOrderToSellerInput = {
  baId: Scalars['ID']['input'];
};

/** 채팅 주문 제안 결과 */
export type RequestChatOrderToSellerResult = {
  __typename?: 'RequestChatOrderToSellerResult';
  error?: Maybe<RequestChatOrderToSellerError>;
  success: Scalars['Boolean']['output'];
};

export type RequestStoreAlarmInput = {
  baId: Scalars['ID']['input'];
};

/** 작성자에게 후기 작성 제재(ReviewRestriction)가 걸려있을 때. */
export type RestrictedStoreProfileReviewError = {
  __typename?: 'RestrictedStoreProfileReviewError';
  message: Scalars['String']['output'];
};

export type Review = Node & ReviewCommon & {
  __typename?: 'Review';
  _id: Scalars['ID']['output'];
  blocked: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  detail?: Maybe<ReviewDetail>;
  id: Scalars['ID']['output'];
  reported: Scalars['Boolean']['output'];
  stopped: Scalars['Boolean']['output'];
};

export type ReviewComment = {
  __typename?: 'ReviewComment';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReviewCommon = {
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ReviewCommonConnection = {
  __typename?: 'ReviewCommonConnection';
  edges: Array<ReviewCommonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewCommonEdge = {
  __typename?: 'ReviewCommonEdge';
  cursor: Scalars['ID']['output'];
  node: ReviewCommon;
};

export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  edges: Array<ReviewEdge>;
  pageInfo: PageInfo;
};

export type ReviewCurationComponent = CurationComponent & Node & {
  __typename?: 'ReviewCurationComponent';
  id: Scalars['ID']['output'];
  reviews: ReviewConnection;
  title: Scalars['String']['output'];
};


export type ReviewCurationComponentReviewsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewDetail = {
  __typename?: 'ReviewDetail';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  likedByMe: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  mediaObjects: Array<ReviewMediaObject>;
  order: Order;
  product?: Maybe<Product>;
  rating: Scalars['Long']['output'];
  region: Region;
  /** 리뷰에 사장님 덧글이 없을 수 있음 */
  reviewComment?: Maybe<ReviewComment>;
  store: Store;
  tags: Array<ReviewTag>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  cursor: Scalars['ID']['output'];
  node: Review;
};

export type ReviewMediaObject = {
  __typename?: 'ReviewMediaObject';
  height: Scalars['Long']['output'];
  id: Scalars['String']['output'];
  mediumUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  type: ReviewMediaObjectType;
  url: Scalars['String']['output'];
  width: Scalars['Long']['output'];
};

export enum ReviewMediaObjectType {
  ExternalPhoto = 'EXTERNAL_PHOTO',
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export enum ReviewSort {
  /**  도움순 */
  MostLiked = 'MOST_LIKED',
  /**  최신순 */
  Newest = 'NEWEST'
}

export type ReviewTag = {
  __typename?: 'ReviewTag';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Reviewable = {
  __typename?: 'Reviewable';
  rejectMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type Reviewer = {
  __typename?: 'Reviewer';
  user: HoianUser;
};

/** 도로명 주소 */
export type RoadAddress = {
  __typename?: 'RoadAddress';
  /** 우편번호 */
  postCode: Scalars['String']['output'];
};

export enum Role {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

/** 스토어 판매 방식 설정 */
export type SaleMethodSetting = {
  __typename?: 'SaleMethodSetting';
  /** 채팅주문 활성화 여부 */
  chatOrderEnabled: Scalars['Boolean']['output'];
  /** 상품 판매 활성화 여부 */
  productSaleEnabled: Scalars['Boolean']['output'];
};

export type SaveBusinessAccountSettlementInput = {
  /**  계좌번호 */
  accountNumber: Scalars['String']['input'];
  /**  통장 사본 */
  accountPhotoId: Scalars['String']['input'];
  /**  은행명 */
  bankName: Scalars['String']['input'];
  /**  연락처 */
  contact: Scalars['String']['input'];
  /**  이메일 주소 */
  email: Scalars['String']['input'];
  /**  예금주명 */
  name: Scalars['String']['input'];
};

export type SaveCartInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Array<CartPayloadInput>>;
  receiveMethod?: InputMaybe<ReceiveMethod>;
  storeId: Scalars['ID']['input'];
  type: Type;
};

export type SaveCartResponse = {
  __typename?: 'SaveCartResponse';
  cart?: Maybe<Cart>;
  cartId: Scalars['ID']['output'];
};

export type SearchFilterInput = {
  fieldName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** 검색 대상 위치 유형 */
export enum SearchWhereType {
  /** produce 홈 */
  ProduceHome = 'PRODUCE_HOME',
  /** 스토어 홈 (스토어 프로필) */
  StoreHome = 'STORE_HOME'
}

export type SelectedOptionSet = {
  __typename?: 'SelectedOptionSet';
  optionSet: OrderProductOptionSet;
  quantity: Scalars['Int']['output'];
};

export type SelectedOptionSetInput = {
  optionSetId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Seller = {
  __typename?: 'Seller';
  /** 판매자의 비즈니스 계정 정보 */
  businessAccount: BusinessAccount;
  /** 판매자가 소유한 모든 비즈니스 계정 목록 */
  businessAccounts: Array<BusinessAccount>;
  /** 소유한 상점 목록 */
  stores: Array<Store>;
};

export type ServiceAdditionalFields = {
  __typename?: 'ServiceAdditionalFields';
  validDays: Scalars['Int']['output'];
};

export type SettlementAggregate = {
  __typename?: 'SettlementAggregate';
  amount: Scalars['Long']['output'];
  count: Scalars['Int']['output'];
  settlementType: Scalars['String']['output'];
};

export type SettlementAggregateData = {
  __typename?: 'SettlementAggregateData';
  amount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
};

export type SettlementConfirmDetail = {
  __typename?: 'SettlementConfirmDetail';
  amount: Scalars['Int']['output'];
  confirmDate: Scalars['Date']['output'];
  confirmStatus: SettlementConfirmStatus;
  orderId: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  paymentDate: Scalars['Date']['output'];
};

export type SettlementConfirmDetailConnection = {
  __typename?: 'SettlementConfirmDetailConnection';
  edges: Array<SettlementConfirmDetailEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SettlementConfirmDetailEdge = {
  __typename?: 'SettlementConfirmDetailEdge';
  cursor: Scalars['ID']['output'];
  node: SettlementConfirmDetail;
};

export enum SettlementConfirmStatus {
  CancelAfterConfirm = 'CANCEL_AFTER_CONFIRM',
  Confirm = 'CONFIRM'
}

export type SettlementDetailConnection = {
  __typename?: 'SettlementDetailConnection';
  edges: Array<SettlementDetailItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** 주문별 정산 상세 항목 */
export type SettlementDetailItem = {
  __typename?: 'SettlementDetailItem';
  /** 주문 금액 */
  amount: Scalars['Long']['output'];
  /** 총 서비스 수수료 */
  feeAmount: Scalars['Long']['output'];
  /** 주문 ID */
  orderId: Scalars['String']['output'];
  /** 주문명 */
  orderName: Scalars['String']['output'];
  /** 결제 상태 */
  payStatus: SettlementPayStatus;
  /** 결제 타입 */
  paymentType?: Maybe<PaymentType>;
  /** 정산일 */
  settlementDate: Scalars['Date']['output'];
};

export type SettlementDetailItemEdge = {
  __typename?: 'SettlementDetailItemEdge';
  cursor: Scalars['ID']['output'];
  node: SettlementDetailItem;
};

export type SettlementFilter = {
  paymentType?: InputMaybe<PaymentType>;
};

export type SettlementHistory = {
  __typename?: 'SettlementHistory';
  amount: Scalars['Long']['output'];
  id: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  paymentDate: Scalars['String']['output'];
  settlementDate: Scalars['String']['output'];
  settlementType: Scalars['String']['output'];
};

export type SettlementHistoryConnection = {
  __typename?: 'SettlementHistoryConnection';
  edges: Array<SettlementHistoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SettlementHistoryEdge = {
  __typename?: 'SettlementHistoryEdge';
  cursor: Scalars['ID']['output'];
  node: SettlementHistory;
};

/** 정산 상세 결제 상태 */
export enum SettlementPayStatus {
  /** 승인 */
  Approve = 'APPROVE',
  /** 없음 */
  None = 'NONE',
  /** 환불 */
  Refund = 'REFUND'
}

/**  Monthly Settlement Query Data */
export type SettlementSummary = {
  __typename?: 'SettlementSummary';
  baId: Scalars['String']['output'];
  depositAmount: Scalars['Long']['output'];
  depositDate: Scalars['String']['output'];
  details: Array<SettlementAggregate>;
  firstSettlementDate?: Maybe<Scalars['Date']['output']>;
  salesFee: Scalars['Long']['output'];
  settlementDateFrom: Scalars['String']['output'];
  settlementDateTo: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  supportAmount: Scalars['Long']['output'];
  totalSettlementsAmount: Scalars['Long']['output'];
};

export enum ShippingRestrictionRegion {
  IslandRemote = 'ISLAND_REMOTE',
  Jeju = 'JEJU'
}

export type SimpleOption = {
  __typename?: 'SimpleOption';
  additionalPrice?: Maybe<Money>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stock?: Maybe<Scalars['Int']['output']>;
  /**  stockFree가 있으면 옵션 재고 수량 설정 안 함 */
  stockFree: Scalars['Boolean']['output'];
};

export type SimpleOptionsInput = {
  additionalPrice?: InputMaybe<MoneyInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stock?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortType {
  Popular = 'POPULAR',
  Recent = 'RECENT'
}

export type StartDeliveryError = StartDeliveryInvalidDeliveryStatusError | StartDeliveryInvalidInvoiceError | StartDeliveryInvalidOrderStatusError | StartDeliveryInvoiceRequiredError;

export enum StartDeliveryErrorType {
  InvalidInvoice = 'INVALID_INVOICE',
  InvoiceRequired = 'INVOICE_REQUIRED'
}

export type StartDeliveryInvalidDeliveryStatusError = {
  __typename?: 'StartDeliveryInvalidDeliveryStatusError';
  deliveryStatus?: Maybe<DeliveryStatus>;
};

export type StartDeliveryInvalidInvoiceError = {
  __typename?: 'StartDeliveryInvalidInvoiceError';
  company: DeliveryCompany;
  invoice: Scalars['String']['output'];
};

export type StartDeliveryInvalidOrderStatusError = {
  __typename?: 'StartDeliveryInvalidOrderStatusError';
  orderStatus?: Maybe<OrderStatus>;
};

/**  운송장 번호가 필수인 서비스 유형(스토어프로필, 채팅주문)에서 운송장 없이 배송시작을 요청한 경우 */
export type StartDeliveryInvoiceRequiredError = {
  __typename?: 'StartDeliveryInvoiceRequiredError';
  serviceType: StartDeliveryInvoiceRequiredServiceType;
};

export enum StartDeliveryInvoiceRequiredServiceType {
  ChatOrder = 'CHAT_ORDER',
  StoreProfile = 'STORE_PROFILE'
}

export type StartDeliveryResponse = {
  __typename?: 'StartDeliveryResponse';
  error?: Maybe<StartDeliveryError>;
  errorType?: Maybe<StartDeliveryErrorType>;
  orderSheet?: Maybe<OrderSheet>;
};

/**  store */
export type Store = Node & {
  __typename?: 'Store';
  /**  store local id */
  _id: Scalars['ID']['output'];
  /** 스토어 주소 */
  address?: Maybe<StoreAddress>;
  /** 스토어프로필 약관 동의 정보 */
  agreement?: Maybe<StoreProfileAgreement>;
  /**  businessAccount which owns the store */
  businessAccount: BusinessAccount;
  /** 채팅주문 상품 후보 목록 (소식 기반 분석 결과) */
  chatOrderProducts: Array<ChatOrderProduct>;
  /** 커버 이미지 목록 (StoreType = STORE_PROFILE 일 경우에만 존재) */
  coverImages: Array<Image>;
  createdAt: Scalars['DateTime']['output'];
  deliverySetting?: Maybe<StoreDeliverySetting>;
  experiments: StoreExperiments;
  /**  해당 스토어 사장님의 확인이 필요한 주문이 있는지. */
  hasOrderToCheck: Scalars['Boolean']['output'];
  /**  store global id */
  id: Scalars['ID']['output'];
  /**  show whether user is seller or not */
  isSeller: Scalars['Boolean']['output'];
  /** 현재 사용자의 구독 여부 (비로그인 시 null) */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /**  required minimum orderAmount, no minCondition if null */
  minConditionPrice?: Maybe<Money>;
  monthlyOrderSummary: MonthlyOrderSummary;
  /** 채팅주문 상품 후보 목록 (14일 이내 최신 소식 최대 2개, 소식 단위 그룹핑) */
  mostRecentChatOrderPosts: Array<ChatOrderPost>;
  /**  store name, now it will equals with ba name */
  name: Scalars['String']['output'];
  ordersByOffset?: Maybe<OrderSheetOffsetPagination>;
  /**  order list */
  ordersByStatus?: Maybe<OrdersByStatus>;
  productExposureRegions: Array<Region>;
  products: ProductConnection;
  productsByOffset?: Maybe<ProductOffsetPagination>;
  productsByStatus: ProductConnection;
  representProductPolicy: RepresentProductPolicy;
  status: StoreStatus;
  storeRequest?: Maybe<StoreRequest>;
  /** 구독자 수 */
  subscriberCount: Scalars['Int']['output'];
  totalOrderCount: Scalars['Int']['output'];
  /** 스토어 타입 */
  type?: Maybe<StoreType>;
};


/**  store */
export type StoreMonthlyOrderSummaryArgs = {
  date: Scalars['String']['input'];
  filter?: InputMaybe<OrderSummaryFilter>;
};


/**  store */
export type StoreOrdersByOffsetArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/**  store */
export type StoreOrdersByStatusArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/**  store */
export type StoreProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortType>;
};


/**  store */
export type StoreProductsByOffsetArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<Type>;
  size?: InputMaybe<Scalars['Int']['input']>;
  statuses: Array<ProductStatus>;
};


/**  store */
export type StoreProductsByStatusArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<Type>;
  sortType?: InputMaybe<SortType>;
  statuses: Array<ProductStatus>;
};


/**  store */
export type StoreStoreRequestArgs = {
  clearInvalidFields?: InputMaybe<Scalars['Boolean']['input']>;
};

/** 스토어 주소 */
export type StoreAddress = {
  __typename?: 'StoreAddress';
  /** 도로명 주소 */
  roadAddress?: Maybe<RoadAddress>;
};

export type StoreConnection = {
  __typename?: 'StoreConnection';
  edges: Array<StoreEdge>;
  pageInfo: PageInfo;
};

export type StoreDeliverySetting = Node & {
  __typename?: 'StoreDeliverySetting';
  _id: Scalars['ID']['output'];
  deliverableRegionGuide?: Maybe<Scalars['String']['output']>;
  deliverableRegionType?: Maybe<DeliverableRegionType>;
  description?: Maybe<Scalars['String']['output']>;
  fee: Money;
  /**  무료배송의 경우 0원 */
  freeConditionPrice?: Maybe<Money>;
  id: Scalars['ID']['output'];
  type: DeliverySettingType;
};

export type StoreEdge = {
  __typename?: 'StoreEdge';
  cursor: Scalars['ID']['output'];
  node: Store;
};

export type StoreExperiments = {
  __typename?: 'StoreExperiments';
  productTypeExperiment: ProductTypeExperimentCase;
};

/**
 * 홈, 기획전, 카테고리 지면을 모두 다루는 새로운 도메인을 만들 예정이에요.
 * 초반에는 빠르게 대응하기 위해서 StoreHome으로 특정해서 반환해요.
 */
export type StoreHome = {
  __typename?: 'StoreHome';
  banners: Array<Banner>;
  products: ProductConnection;
};


/**
 * 홈, 기획전, 카테고리 지면을 모두 다루는 새로운 도메인을 만들 예정이에요.
 * 초반에는 빠르게 대응하기 위해서 StoreHome으로 특정해서 반환해요.
 */
export type StoreHomeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

/** 스토어를 찾을 수 없음 */
export type StoreNotFound = {
  __typename?: 'StoreNotFound';
  message: Scalars['String']['output'];
};

export type StoreOrder = Node & {
  __typename?: 'StoreOrder';
  _id: Scalars['ID']['output'];
  /** 결제 금액 기준 사용 가능한 쿠폰 조회 */
  availableCoupons: AvailableCouponConnection;
  buyer: Buyer;
  cancelInfo?: Maybe<CancelInfo>;
  /** 주문 출처 (상품주문/채팅주문) */
  channelType: OrderChannelType;
  createdAt: Scalars['DateTime']['output'];
  customerInfo?: Maybe<CustomerInfo>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  deliveryInfo?: Maybe<DeliveryInfo>;
  failureInfo?: Maybe<FailureInfo>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderSheet: OrderSheet;
  orders: Array<Order>;
  payment: Payment;
  productType: Type;
  purchaseConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  receiveMethod?: Maybe<ReceiveMethod>;
  /** 주문 완료 페이지 유관 상품 추천 */
  relatedProducts: Array<Product>;
  status: OrderStatus;
  store: OrderStore;
  totalOrderOptionQuantity: Scalars['Int']['output'];
};


export type StoreOrderAvailableCouponsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<AvailableCouponsFilter>;
};


export type StoreOrderRelatedProductsArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type StoreOrderConnection = {
  __typename?: 'StoreOrderConnection';
  edges: Array<StoreOrderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StoreOrderEdge = {
  __typename?: 'StoreOrderEdge';
  cursor: Scalars['ID']['output'];
  node: StoreOrder;
};

export type StoreOrderMetadataInput = {
  /** 채팅 메타데이터 */
  chat?: InputMaybe<ChatMetadataInput>;
};

/** 스토어프로필 약관 동의 정보 */
export type StoreProfileAgreement = {
  __typename?: 'StoreProfileAgreement';
  /** 스토어프로필 상품판매 이용약관 동의 시각 */
  agreedToStoreProfileProductSaleAt?: Maybe<Scalars['DateTime']['output']>;
};

/** 후기 본문의 얇은 래퍼. 상태 플래그는 항상 노출되고, detail 은 가시성 정책에 따라 null 처리된다. */
export type StoreProfileReview = Node & StoreProfileReviewCommon & {
  __typename?: 'StoreProfileReview';
  _id: Scalars['ID']['output'];
  blocked: Scalars['Boolean']['output'];
  /**
   * 후기 상태 플래그. 아래 조합으로 가시성 레벨이 파생된다.
   * - deleted=true                 → HIDDEN
   * - blocked=true / stopped=true  → ONLY_AUTHOR (detail 은 작성자에게만)
   * - reported=true                → ALL (신고됨 표시만 노출, 컨텐츠는 공개 유지)
   */
  deleted: Scalars['Boolean']['output'];
  /** 후기 상세. 가시성 정책상 ACTIVE / REPORTED 만 비작성자에게 노출된다. */
  detail?: Maybe<StoreProfileReviewDetail>;
  id: Scalars['ID']['output'];
  reported: Scalars['Boolean']['output'];
  stopped: Scalars['Boolean']['output'];
};

/** 사장님 답글. 후기 1건당 1건만 존재 가능. */
export type StoreProfileReviewComment = {
  __typename?: 'StoreProfileReviewComment';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 *  ============================================================
 *  Domain Types
 *    Review 래퍼(상태 플래그) + Detail(실제 본문/관계) 로 분리.
 *    가시성 정책에 따라 detail 이 null 일 수 있고, 상태 플래그만으로
 *    "삭제됨 / 차단됨" 플레이스홀더 UI 를 그릴 수 있다.
 *  ============================================================
 */
export type StoreProfileReviewCommon = {
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type StoreProfileReviewConnection = {
  __typename?: 'StoreProfileReviewConnection';
  edges: Array<StoreProfileReviewEdge>;
  pageInfo: PageInfo;
};

/** 후기 본문 + 관계 필드. */
export type StoreProfileReviewDetail = {
  __typename?: 'StoreProfileReviewDetail';
  _id: Scalars['ID']['output'];
  /** 후기 본문. */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 첨부된 사진/영상 미디어. 최대 10개, displayOrder 오름차순. */
  mediaObjects: Array<StoreProfileReviewMedia>;
  /** 작성 당시 해당 상품 구매 횟수. 재구매 이력 노출용. */
  numberOfPurchase: Scalars['Int']['output'];
  /** 후기의 근거가 된 주문. */
  order: Order;
  /** 후기가 작성된 상품. 상품이 이미 삭제된 경우 null. */
  product?: Maybe<Product>;
  /** 별점 (1 ~ 5). 본문은 작성 즉시 노출되며, 1~3점은 평균 별점 집계에 +7일 뒤에 반영된다. */
  rating: Scalars['Int']['output'];
  /** 현재 로그인 유저가 이 후기에 리액션을 남겼는지. 비로그인은 false. */
  reactedByMe: Scalars['Boolean']['output'];
  /** 리액션 총합. */
  reactionCount: Scalars['Int']['output'];
  /** 사장님 답글. 아직 달리지 않았거나 삭제된 경우 null. */
  reviewComment?: Maybe<StoreProfileReviewComment>;
  /** 후기 작성자. */
  reviewer: StoreProfileReviewer;
  /** 후기가 달린 비즈프로필 스토어. */
  store: Store;
  /** 부여된 큐레이션 태그 목록. */
  tags: Array<StoreProfileReviewTag>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 *  ============================================================
 *  Pagination
 *  ============================================================
 */
export type StoreProfileReviewEdge = {
  __typename?: 'StoreProfileReviewEdge';
  /** 다음 페이지 요청 시 after 로 사용할 cursor. */
  cursor: Scalars['ID']['output'];
  node: StoreProfileReview;
};

/** 후기 리스트 필터. */
export type StoreProfileReviewFilter = {
  /** 노출할 미디어 타입 목록. 비어있거나 null 이면 미디어 필터 미적용. */
  mediaTypes?: InputMaybe<Array<StoreProfileReviewMediaType>>;
};

/** 사진 후기. pictureId 가 외부 사진 서비스 참조. */
export type StoreProfileReviewImage = StoreProfileReviewMedia & {
  __typename?: 'StoreProfileReviewImage';
  displayOrder: Scalars['Int']['output'];
  /** 원본 세로 픽셀. */
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** 중간 크기 URL (목록용). */
  mediumUrl?: Maybe<Scalars['String']['output']>;
  pictureId: Scalars['String']['output'];
  /** 썸네일 URL. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** 원본 크기 URL. */
  url?: Maybe<Scalars['String']['output']>;
  /** 원본 가로 픽셀. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** 사진 첨부 input. 외부 사진 서비스에서 업로드 완료 후 받은 pictureId. */
export type StoreProfileReviewImageInput = {
  pictureId: Scalars['String']['input'];
};

/**
 *  ============================================================
 *  Media
 *    image / video 중 하나로 분기. URL · 해상도 · 썸네일 등은
 *    외부 미디어 서비스 조회로 채워지므로 nullable.
 *  ============================================================
 */
export type StoreProfileReviewMedia = {
  /** 목록에서의 정렬 순서 (0 기준, 오름차순). */
  displayOrder: Scalars['Int']['output'];
  /** 외부 미디어 서비스 참조 ID. */
  id: Scalars['String']['output'];
};

/** 미디어 1건. image / video 중 정확히 한 필드만 세팅. */
export type StoreProfileReviewMediaInput = {
  displayOrder: Scalars['Int']['input'];
  /** 사진 첨부. video 와 동시 세팅 불가. */
  image?: InputMaybe<StoreProfileReviewImageInput>;
  /** 영상 첨부. image 와 동시 세팅 불가. */
  video?: InputMaybe<StoreProfileReviewVideoInput>;
};

/** 필터에서 사용하는 미디어 타입. */
export enum StoreProfileReviewMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

/** 판매자용 후기 페이지네이션. */
export type StoreProfileReviewOffsetPagination = {
  __typename?: 'StoreProfileReviewOffsetPagination';
  nodes: Array<StoreProfileReview>;
  pageInfo: OffsetPageInfo;
};

/** 후기 리액션 종류. */
export enum StoreProfileReviewReactionType {
  /** 도움돼요 */
  Helpful = 'HELPFUL'
}

/** 판매자용 후기 필터. */
export type StoreProfileReviewSellerFilter = {
  /** false → 답글 없는 후기, true → 답글 있는 후기, null → 전체. */
  hasComment?: InputMaybe<Scalars['Boolean']['input']>;
  /** 특정 고객(리뷰어) 의 후기만 조회. */
  reviewerId?: InputMaybe<Scalars['ID']['input']>;
};

/** 판매자용 후기 정렬. */
export enum StoreProfileReviewSellerSort {
  /** 도움순 */
  MostLiked = 'MOST_LIKED',
  /** 최신순 */
  Newest = 'NEWEST'
}

/** 스토어 / 상품 후기 리스트의 정렬 기준. */
export enum StoreProfileReviewSort {
  /** 도움순 — 도움돼요 집계 기준 내림차순. */
  MostLiked = 'MOST_LIKED',
  /** 최신순 — 작성 시각 기준 내림차순. */
  Newest = 'NEWEST',
  /** 별점 높은 순. */
  RatingHigh = 'RATING_HIGH',
  /** 별점 낮은 순. */
  RatingLow = 'RATING_LOW'
}

/**
 *  ============================================================
 *  Stats
 *    상품 상세에서 노출하는 후기 요약 지표.
 *  ============================================================
 */
export type StoreProfileReviewStats = {
  __typename?: 'StoreProfileReviewStats';
  /** 만족도 (%, 0 ~ 100). 별점 4 / 5 점의 비율. */
  reviewSatisfiedRate: Scalars['Float']['output'];
  /** 평균 별점. 후기 수가 0이면 0.0. */
  reviewStarRatingAverage: Scalars['Float']['output'];
  /** 활성 후기의 총 개수 (삭제/차단 제외). */
  reviewTotalCount: Scalars['Int']['output'];
  /** '상품 리뷰' 로 분류된 후기 총 개수. */
  reviewTotalCountExcludeProduct: Scalars['Int']['output'];
};

/** 큐레이션 태그. */
export type StoreProfileReviewTag = {
  __typename?: 'StoreProfileReviewTag';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** 영상 후기. streamId 가 외부 스트리밍 서비스 참조. */
export type StoreProfileReviewVideo = StoreProfileReviewMedia & {
  __typename?: 'StoreProfileReviewVideo';
  displayOrder: Scalars['Int']['output'];
  /** 영상 길이 (초). */
  duration?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  streamId: Scalars['String']['output'];
  /** 대표 썸네일 URL. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** 재생 URL. */
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** 영상 첨부 input. 외부 스트리밍 서비스에서 업로드 완료 후 받은 streamId. */
export type StoreProfileReviewVideoInput = {
  streamId: Scalars['String']['input'];
};

/** 후기 작성자. */
export type StoreProfileReviewer = {
  __typename?: 'StoreProfileReviewer';
  /** 이 후기가 달린 비즈프로필의 단골(팔로워) 여부. */
  isSubscribed: Scalars['Boolean']['output'];
  user: HoianUser;
};

/**  사업자 정보 */
export type StoreRegistration = {
  __typename?: 'StoreRegistration';
  /**
   *  추가 증빙 서류 이미지 URL
   * @deprecated No longer supported
   */
  additionalLicencePhotoUrls?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *  use additionalLicencePhotoIds instead
   *  추가 증빙 서류 이미지
   */
  additionalLicencePhotos?: Maybe<Array<Image>>;
  /**
   *  사업장 주소
   * @deprecated No longer supported
   */
  address?: Maybe<Scalars['String']['output']>;
  /**  종목 */
  businessCategory: Scalars['String']['output'];
  /**
   *  use roadAddress & detailAddress instead
   *  연락처
   */
  contact: Scalars['String']['output'];
  /**  사업장 상세 주소 */
  detailAddress?: Maybe<Scalars['String']['output']>;
  /**  업태 */
  industry: Scalars['String']['output'];
  /**  상호명 */
  name: Scalars['String']['output'];
  /**  대표자명 */
  ownerName: Scalars['String']['output'];
  /**  사업자등록번호 */
  registrationNumber: Scalars['String']['output'];
  /**
   *  사업자등록증 사본
   * @deprecated No longer supported
   */
  registrationPaperPhotoId: Scalars['String']['output'];
  registrationPaperPhotoUrl: Scalars['String']['output'];
  /**  사업장 지번 주소 */
  roadAddress?: Maybe<Scalars['String']['output']>;
  /**  사업자 유형 */
  type: RegistrationType;
};

/**  사업자 정보 입력 */
export type StoreRegistrationInput = {
  /**  추가 증빙 서류 리스트 */
  additionalLicencePhotoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  사업장 주소 */
  address?: InputMaybe<Scalars['String']['input']>;
  /**  종목 */
  businessCategory: Scalars['String']['input'];
  /**
   *  @deprecated: use roadAddress & detailAddress instead
   *  연락처
   */
  contact: Scalars['String']['input'];
  /**  사업장 상세 주소 */
  detailAddress?: InputMaybe<Scalars['String']['input']>;
  /**  업태 */
  industry: Scalars['String']['input'];
  /**  대표자명 */
  ownerName: Scalars['String']['input'];
  /**  상호명 */
  registrationName: Scalars['String']['input'];
  /**  사업자등록번호 */
  registrationNumber: Scalars['String']['input'];
  /**  사업자등록증 사본 */
  registrationPhotoUrl: Scalars['String']['input'];
  /**  사업자 유형 */
  registrationType: RegistrationType;
  /**  사업장 지번 주소 */
  roadAddress?: InputMaybe<Scalars['String']['input']>;
};

export type StoreRejectInvalidInputField = {
  __typename?: 'StoreRejectInvalidInputField';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export enum StoreRejectReason {
  CategoryNotAllowed = 'CATEGORY_NOT_ALLOWED',
  Custom = 'CUSTOM',
  InvalidBizProfile = 'INVALID_BIZ_PROFILE',
  InvalidBusinessLicense = 'INVALID_BUSINESS_LICENSE',
  InvalidInput = 'INVALID_INPUT',
  RegionNotAllowed = 'REGION_NOT_ALLOWED'
}

/**
 * type StoreDeliverySettingEdge {
 *     node: StoreDeliverySetting!
 *     cursor: ID!
 * }
 * type StoreDeliverySettingConnection {
 *     edges: [BusinessAccountEdge!]!
 *     pageInfo: PageInfo!
 * }
 *  입점 신청 엔터티
 */
export type StoreRequest = {
  __typename?: 'StoreRequest';
  _id: Scalars['ID']['output'];
  additionalLicencePhotos: Array<Image>;
  /** 채팅주문 이용약관 동의 시각 (null = 동의 안함) */
  agreedToChatOrderTermsOfServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /** 상품판매 이용약관 동의 시각 (null = 동의 안함) */
  agreedToTermsOfServiceAt?: Maybe<Scalars['DateTime']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  baId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   *  사업자 정보
   * @deprecated No longer supported
   */
  registration: StoreRegistration;
  /**  반려 정보 */
  rejectInfo?: Maybe<RejectInfo>;
  /** @deprecated No longer supported */
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *  moved to RejectInfo
   * @deprecated No longer supported
   */
  rejectedBy?: Maybe<Scalars['String']['output']>;
  /**  정산 정보 */
  settlement?: Maybe<StoreSettlement>;
  status: StoreRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type StoreRequestAbility = {
  __typename?: 'StoreRequestAbility';
  /**
   *  입점 신청 가능 여부
   * @deprecated No longer supported
   */
  availableToRequest: Scalars['Boolean']['output'];
  /**  입점 신청 가능한 유형 */
  availableType?: Maybe<StoreRequestAbilityType>;
  /**  입점 신청 유도 여부 */
  inducedToRequest: Scalars['Boolean']['output'];
  /**  사전알림신청 가능 여부 */
  openAlarmAbility?: Maybe<OpenAlarmRequestAbilityStatus>;
  /**  사전알림신청 */
  requestedAlarm?: Maybe<StoreRequestAlarm>;
  /**  입점 신청 상태, to be non-nullable */
  status?: Maybe<StoreRequestAbilityStatus>;
  /**  입점 신청 불가 이유 */
  unavailableToRequestReason?: Maybe<StoreRequestUnavailableReason>;
};

export enum StoreRequestAbilityStatus {
  Available = 'AVAILABLE',
  /**  반려된 상태 */
  NotAllowed = 'NOT_ALLOWED',
  /**  입점 신청 가능 */
  Pending = 'PENDING',
  /**  입점 신청 결과 대기중 */
  Rejected = 'REJECTED'
}

export enum StoreRequestAbilityType {
  Default = 'DEFAULT',
  VoucherTicket = 'VOUCHER_TICKET'
}

export type StoreRequestAlarm = {
  __typename?: 'StoreRequestAlarm';
  createdAt: Scalars['DateTime']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
};

export enum StoreRequestStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export enum StoreRequestUnavailableReason {
  /** @deprecated No longer supported */
  AlreadyRequested = 'ALREADY_REQUESTED',
  StoreExists = 'STORE_EXISTS',
  UnavailableCategory = 'UNAVAILABLE_CATEGORY',
  UnavailableRegion = 'UNAVAILABLE_REGION',
  UnavailableType = 'UNAVAILABLE_TYPE'
}

export type StoreReview = Node & ReviewCommon & {
  __typename?: 'StoreReview';
  _id: Scalars['ID']['output'];
  blocked: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  detail?: Maybe<StoreReviewDetail>;
  id: Scalars['ID']['output'];
  reported: Scalars['Boolean']['output'];
  stopped: Scalars['Boolean']['output'];
};

export type StoreReviewDetail = {
  __typename?: 'StoreReviewDetail';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  likedByMe: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  mediaObjects: Array<ReviewMediaObject>;
  rating: Scalars['Long']['output'];
  region: Region;
  /** 리뷰에 사장님 덧글이 없을 수 있음 */
  reviewComment?: Maybe<ReviewComment>;
  reviewer: Reviewer;
  store: Store;
  updatedAt: Scalars['DateTime']['output'];
};

/**  정산 정보 */
export type StoreSettlement = {
  __typename?: 'StoreSettlement';
  /**  계좌번호 */
  accountNumber: Scalars['String']['output'];
  /**  통장 사본 */
  accountPhotoId: Scalars['String']['output'];
  /**  은행명 */
  bankName: Scalars['String']['output'];
  /**  이메일 주소 */
  email: Scalars['String']['output'];
  /**  예금주명 */
  name: Scalars['String']['output'];
};

/**  정산 정보 입력 */
export type StoreSettlementInput = {
  /**  예금주명 */
  accountHolder: Scalars['String']['input'];
  /**  계좌번호 */
  accountNumber: Scalars['String']['input'];
  /**  통장 사본 */
  accountPhotoUrl: Scalars['String']['input'];
  /**  은행명 */
  bankName: Scalars['String']['input'];
  /**  이메일 주소 */
  email: Scalars['String']['input'];
};

export enum StoreStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum StoreType {
  /** 로컬프로필 */
  LocalProfile = 'LOCAL_PROFILE',
  /** 스토어프로필 */
  StoreProfile = 'STORE_PROFILE'
}

export type StringAttributeValue = {
  __typename?: 'StringAttributeValue';
  value: Scalars['String']['output'];
};

/** 캠페인 구독 입력 */
export type SubscribeCampaignInput = {
  /** 마케팅 수신 동의 여부 */
  agreeToMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** 캠페인 ID */
  campaignId: Scalars['ID']['input'];
};

/** 캠페인 구독 결과 */
export type SubscribeCampaignResult = {
  __typename?: 'SubscribeCampaignResult';
  /** 구독된 캠페인 */
  campaign?: Maybe<Campaign>;
  /** 에러 */
  error?: Maybe<ErrorSubscribeCampaign>;
};

export type SurveyBanner = {
  __typename?: 'SurveyBanner';
  targetUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum TaxType {
  Taxable = 'TAXABLE',
  TaxFree = 'TAX_FREE'
}

export type TemplateItem = {
  __typename?: 'TemplateItem';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TemplateItemInput = {
  dataKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** 이용약관 미동의 */
export type TermsNotAgreed = {
  __typename?: 'TermsNotAgreed';
  message: Scalars['String']['output'];
};

export type Theme = {
  __typename?: 'Theme';
  products: ProductConnection;
  reviews: Array<Review>;
  stores: StoreConnection;
};


export type ThemeProductsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  baCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
  sortType?: InputMaybe<SortType>;
};


export type ThemeReviewsArgs = {
  baCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  regionId: Scalars['ID']['input'];
};


export type ThemeStoresArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  baCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
  sortType?: InputMaybe<SortType>;
};

export enum Type {
  Custom = 'CUSTOM',
  Goods = 'GOODS',
  Service = 'SERVICE'
}

export type UnauthorizedBusinessAccountAccess = {
  __typename?: 'UnauthorizedBusinessAccountAccess';
  message: Scalars['String']['output'];
};

/** 문의 접근 권한 없음 */
export type UnauthorizedInquiryAccess = {
  __typename?: 'UnauthorizedInquiryAccess';
  message: Scalars['String']['output'];
};

/** 스토어 접근 권한 없음 */
export type UnauthorizedStoreAccess = {
  __typename?: 'UnauthorizedStoreAccess';
  message: Scalars['String']['output'];
};

/**
 * 권한 없음.
 * - 후기 수정/삭제: 작성자 본인이 아닌 유저의 시도
 * - 후기 수정: 결제 완료 후 수정 가능 기간 경과
 * - 사장님 답글 생성/수정/삭제: 해당 후기의 비즈프로필 BA 가 아닌 다른 판매자의 시도
 */
export type UnauthorizedStoreProfileReviewError = {
  __typename?: 'UnauthorizedStoreProfileReviewError';
  message: Scalars['String']['output'];
};

/** 예상치 못한 오류 */
export type UnexpectedError = {
  __typename?: 'UnexpectedError';
  message: Scalars['String']['output'];
};

/** 캠페인 구독 해제 입력 */
export type UnsubscribeCampaignInput = {
  /** 캠페인 ID */
  campaignId: Scalars['ID']['input'];
  /** 마케팅 수신 철회 여부 */
  revokeMarketing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** 캠페인 구독 해제 결과 */
export type UnsubscribeCampaignResult = {
  __typename?: 'UnsubscribeCampaignResult';
  /** 구독 해제된 캠페인 */
  campaign?: Maybe<Campaign>;
  /** 에러 */
  error?: Maybe<ErrorUnsubscribeCampaign>;
};

export type UpdateDefaultDeliveryAddressResponse = {
  __typename?: 'UpdateDefaultDeliveryAddressResponse';
  edge: DeliveryAddressEdge;
};

export type UpdateInquiryResult = {
  __typename?: 'UpdateInquiryResult';
  error?: Maybe<ErrorUpdateInquiry>;
  productInquiry?: Maybe<ProductInquiry>;
};

export type UpdateProductInput = {
  attributes?: InputMaybe<Array<ProductAttributeInput>>;
  categoryId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  discountExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  goodsInput?: InputMaybe<CreateGoodsProductInput>;
  name: Scalars['String']['input'];
  price: MoneyInput;
  productType: Type;
  salePrice?: InputMaybe<MoneyInput>;
  serviceInput?: InputMaybe<CreateServiceProductInput>;
  simpleOptions: Array<SimpleOptionsInput>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  taxType?: InputMaybe<TaxType>;
  templates?: InputMaybe<Array<TemplateItemInput>>;
  thumbnailIds: Array<Scalars['ID']['input']>;
};

export type UpdateProductInquiryInput = {
  /** 내용 */
  content: Scalars['String']['input'];
  /** 문의하기 ID */
  inquiryId: Scalars['ID']['input'];
  /** 숨김처리 여부 */
  isSecret?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateReviewCommentInput = {
  content: Scalars['String']['input'];
  reviewCommentId: Scalars['ID']['input'];
  reviewId: Scalars['ID']['input'];
};

export type UpdateReviewInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  pictureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewId: Scalars['ID']['input'];
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateStoreCoverImagesError = InvalidStore | StoreNotFound | UnauthorizedStoreAccess;

/**  스토어 커버 이미지 업데이트 관련 타입 */
export type UpdateStoreCoverImagesInput = {
  pictureIds: Array<Scalars['String']['input']>;
  storeId: Scalars['ID']['input'];
};

export type UpdateStoreCoverImagesResult = {
  __typename?: 'UpdateStoreCoverImagesResult';
  error?: Maybe<UpdateStoreCoverImagesError>;
  store?: Maybe<Store>;
};

export type UpdateStoreDeliveryInput = {
  fee?: InputMaybe<MoneyInput>;
  freeConditionPrice?: InputMaybe<MoneyInput>;
  storeId: Scalars['ID']['input'];
  type: DeliveryType;
};

export type UpdateStoreDeliverySettingInput = {
  /**  당일 배송 안내 */
  deliverableRegionGuide?: InputMaybe<Scalars['String']['input']>;
  deliverableRegionType?: InputMaybe<DeliverableRegionType>;
  deliveryType: DeliverySettingType;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<MoneyInput>;
  feeType: DeliverySettingFeeType;
  freeConditionPrice?: InputMaybe<MoneyInput>;
  storeId: Scalars['ID']['input'];
};

export type UpdateStoreMinConditionPriceInput = {
  minConditionPrice?: InputMaybe<MoneyInput>;
  storeId: Scalars['ID']['input'];
};

/** 사장님 답글 수정. 본인 BA 가 달아놓은 답글만. */
export type UpdateStoreProfileReviewCommentInput = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type UpdateStoreProfileReviewCommentResult = {
  __typename?: 'UpdateStoreProfileReviewCommentResult';
  error?: Maybe<ErrorUpdateStoreProfileReviewComment>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

/** 후기 수정 요청. 결제 완료 후 3개월 내 + 작성자 본인 조건. */
export type UpdateStoreProfileReviewInput = {
  content: Scalars['String']['input'];
  mediaObjects?: Array<StoreProfileReviewMediaInput>;
  rating: Scalars['Int']['input'];
  reviewId: Scalars['ID']['input'];
  tagIds?: Array<Scalars['ID']['input']>;
};

export type UpdateStoreProfileReviewResult = {
  __typename?: 'UpdateStoreProfileReviewResult';
  error?: Maybe<ErrorUpdateStoreProfileReview>;
  storeProfileReview?: Maybe<StoreProfileReview>;
};

export type UpdateStoreRequestV2Input = {
  baId: Scalars['ID']['input'];
};

/** 사용 가능 대상 */
export type UsableTarget = {
  __typename?: 'UsableTarget';
  /** 카테고리 */
  category?: Maybe<Scalars['String']['output']>;
  /** 참조 ID */
  referenceId?: Maybe<Scalars['ID']['output']>;
};

export type VerticalSearch = {
  __typename?: 'VerticalSearch';
  latestSearchKeyword?: Maybe<Array<LatestSearchKeyword>>;
  recommendKeywords?: Maybe<Array<RecommendKeyword>>;
  /** @deprecated Use recommendProductsBySearch instead */
  recommendProducts?: Maybe<Array<Product>>;
  recommendProductsBySearch?: Maybe<Array<ProductWrapperForSearch>>;
  searchResult?: Maybe<VerticalSearchResultConnection>;
};


export type VerticalSearchLatestSearchKeywordArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalSearchWhereInput>;
};


export type VerticalSearchRecommendKeywordsArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalSearchWhereInput>;
};


export type VerticalSearchRecommendProductsArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type VerticalSearchRecommendProductsBySearchArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalSearchWhereInput>;
};


export type VerticalSearchSearchResultArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VerticalSearchInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalSearchWhereInput>;
};

export type VerticalSearchInput = {
  keyword: Scalars['String']['input'];
  referrer: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};

export type VerticalSearchResult = Node & {
  __typename?: 'VerticalSearchResult';
  /**  상품 ID? 검색에서 별도로 주는 unique id 가 있다면 해당 id 사용. global unique 해야함. */
  content: Content;
  highlight?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

export type VerticalSearchResultConnection = {
  __typename?: 'VerticalSearchResultConnection';
  edges: Array<VerticalSearchResultEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VerticalSearchResultEdge = {
  __typename?: 'VerticalSearchResultEdge';
  cursor: Scalars['String']['output'];
  node: VerticalSearchResult;
};

/** 검색 where 조건 입력 */
export type VerticalSearchWhereInput = {
  /** 검색 위치 유형 (필수, 기본값: PRODUCE_HOME) */
  searchWhere: SearchWhereType;
};

export type VoucherProductAdditionalFields = {
  __typename?: 'VoucherProductAdditionalFields';
  name: Scalars['String']['output'];
};

export type VoucherTicketProductAdditionalFields = {
  __typename?: 'VoucherTicketProductAdditionalFields';
  benefit?: Maybe<Scalars['String']['output']>;
  validDays: Scalars['Int']['output'];
};

export enum WebviewVersion {
  /**  half view karrotpay webview module */
  Version_1 = 'VERSION_1',
  /**  full page karrotpay webview module */
  Version_2 = 'VERSION_2'
}

export type CreateChatStoreOrderMutationVariables = Exact<{
  input: CreateChatStoreOrderInput;
}>;


export type CreateChatStoreOrderMutation = { __typename?: 'Mutation', createChatStoreOrder: { __typename?: 'CreateChatStoreOrderResult', chatStoreOrder?: { __typename?: 'ChatStoreOrder', storeOrder: { __typename?: 'StoreOrder', id: string, status: OrderStatus, name: string } } | null, error?:
      | { __typename?: 'ChatOrderInvalidOrder', message: string }
      | { __typename?: 'ChatOrderStoreNotFound', message: string }
      | { __typename?: 'ChatOrderStoreNotOwned', message: string }
     | null } };

export type OrderSheetByIdQueryVariables = Exact<{
  storeOrderId: Scalars['ID']['input'];
}>;


export type OrderSheetByIdQuery = { __typename?: 'Query', orderSheet?: { __typename?: 'OrderSheet', deliveryTracking?: { __typename?: 'OrderDeliveryTracking', invoice: string } | null } | null };

export type BusinessAccountChatOrderFieldsFragment = { __typename?: 'BusinessAccount', status: BusinessAccountStatus, isChatOrderTarget: boolean, businessRegistration?: { __typename?: 'BusinessRegistration', inspectionStatus: BusinessAccountInspectionStatus } | null, settlement?: { __typename?: 'BusinessAccountSettlement', accountNumber: string } | null, saleMethodSetting?: { __typename?: 'SaleMethodSetting', chatOrderEnabled: boolean } | null };

export type GetChatOrderEligibilityQueryVariables = Exact<{
  baId: Scalars['ID']['input'];
}>;


export type GetChatOrderEligibilityQuery = { __typename?: 'Query', baById?: { __typename?: 'BusinessAccount', status: BusinessAccountStatus, isChatOrderTarget: boolean, businessRegistration?: { __typename?: 'BusinessRegistration', inspectionStatus: BusinessAccountInspectionStatus } | null, settlement?: { __typename?: 'BusinessAccountSettlement', accountNumber: string } | null, saleMethodSetting?: { __typename?: 'SaleMethodSetting', chatOrderEnabled: boolean } | null } | null, store?: { __typename?: 'Store', _id: string, mostRecentChatOrderPosts: Array<{ __typename?: 'ChatOrderPost', businessPostId: string, title: string, products: Array<{ __typename?: 'ChatOrderProduct', _id: string, name: string, deliveryFeeOptions: Array<{ __typename?: 'ChatOrderDeliveryFeeOption', name: string, fee: { __typename?: 'Money', amount: number } }>, price?: { __typename?: 'Money', amount: number, currency: MoneyCurrency } | null, thumbnail?: { __typename?: 'Image', _id: string, thumbnail: string, url: string } | null, options: Array<{ __typename?: 'ChatOrderProductOption', _id: string, name: string, price?: { __typename?: 'Money', amount: number, currency: MoneyCurrency } | null }> }> }> } | null };

export type CreateStoreAndAgreementMutationVariables = Exact<{
  input: CreateStoreAndAgreementRequestInput;
}>;


export type CreateStoreAndAgreementMutation = { __typename?: 'Mutation', createStoreAndAgreement: { __typename?: 'CreateStoreAndAgreementResult', isNewStore?: boolean | null, store?: { __typename?: 'Store', id: string, _id: string, businessAccount: { __typename?: 'BusinessAccount', status: BusinessAccountStatus, isChatOrderTarget: boolean, businessRegistration?: { __typename?: 'BusinessRegistration', inspectionStatus: BusinessAccountInspectionStatus } | null, settlement?: { __typename?: 'BusinessAccountSettlement', accountNumber: string } | null, saleMethodSetting?: { __typename?: 'SaleMethodSetting', chatOrderEnabled: boolean } | null } } | null, error?:
      | { __typename?: 'BusinessAccountNotFound', message: string }
      | { __typename?: 'InvalidSaleMethodSetting', message: string }
      | { __typename?: 'TermsNotAgreed', message: string }
     | null } };

export type StartDeliveryV2MutationVariables = Exact<{
  storeOrderId: Scalars['ID']['input'];
  company?: InputMaybe<DeliveryCompany>;
  invoice?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartDeliveryV2Mutation = { __typename?: 'Mutation', startDeliveryV2?: { __typename?: 'StartDeliveryResponse', orderSheet?: { __typename?: 'OrderSheet', body: { __typename?: 'StoreOrder', status: OrderStatus, deliveryInfo?: { __typename?: 'DeliveryInfo', status: DeliveryStatus } | null } } | null, error?:
      | { __typename: 'StartDeliveryInvalidDeliveryStatusError', deliveryStatus?: DeliveryStatus | null }
      | { __typename: 'StartDeliveryInvalidInvoiceError', company: DeliveryCompany, invoice: string }
      | { __typename: 'StartDeliveryInvalidOrderStatusError', orderStatus?: OrderStatus | null }
      | { __typename: 'StartDeliveryInvoiceRequiredError' }
     | null } | null };

export type GetHoianUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetHoianUserQuery = { __typename?: 'Query', hoianUserById?: { __typename?: 'HoianUser', _id: string, nickname: string } | null };

export type GetFeatureFlagByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetFeatureFlagByNameQuery = { __typename?: 'Query', featureFlagByName: { __typename?: 'FeatureFlagByName', enabled: boolean, name: string } };
